import { Component, Story, Knobs, Accents } from './DocTypes';

const DataTypesStory: Story = {
  title: 'Data types',
  description: 'All the different data types that a column can take',
  coreComponent: {
    html: `<tag-table>
  <tag-table-column name='image' caption='Image' data-type='image' cell-width='40px'></tag-table-column>
  <tag-table-column name='icon' caption='Icon' data-type='icon'></tag-table-column>
  <tag-table-column name='string' caption='String' data-type='string'></tag-table-column>
  <tag-table-column name='boolean' caption='Boolean' data-type='boolean'></tag-table-column>
  <tag-table-column name='number' caption='Currency' data-type='currency'></tag-table-column>
  <tag-table-column name='date' caption='Date' data-type='date'></tag-table-column>
  <tag-table-column name='date' caption='Date & Time' data-type='datetime'></tag-table-column>
  <tag-table-column name='number' caption='Decimal' data-type='decimal'></tag-table-column>
  <tag-table-column name='email' caption='Email' data-type='email'></tag-table-column>
  <tag-table-column name='number' caption='Integer' data-type='integer'></tag-table-column>
  <tag-table-column name='number' caption='Number' data-type='number'></tag-table-column>
  <tag-table-column name='phonenumber' caption='Phone Number' data-type='phonenumber'></tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [
  {
    string: 'test1',
    boolean: true,
    date: '2018-07-18T10:09:30.662Z',
    email: 'test1@test.com',
    number: 10.5,
    phonenumber: '072343456',
    icon: 'Bug',
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
  },
  {
    string: 'test2',
    boolean: false,
    date: '2018-05-17T09:03:20.662Z',
    email: 'test2@test.com',
    number: 5.75,
    phonenumber: '0713432494',
    icon: 'Castle',
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
  },
  {
    string: 'test3',
    boolean: true,
    date: '2017-09-16T07:03:10.662Z',
    email: 'test3@test.com',
    number: 7,
    phonenumber: '0779236287',
    icon: 'Diamond',
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
  },
];
`,
  },
  reactWrapper: {
    jsx: `<TagTable
  columns={[
    {name:'image', caption:'Image', dataType:'image', cellInnerStyle: { height: '40px' }},
    {name:'icon', caption:'Icon', dataType:'icon'},
    {name:'string', caption:'String', dataType:'string'},
    {name:'boolean', caption:'Boolean', dataType:'boolean'},
    {name:'number', key: 'currency', caption:'Currency', dataType:'currency'},
    {name:'date', caption:'Date', dataType:'date'},
    {name:'date', key: 'datetime', caption:'Date & Time', dataType:'datetime'},
    {name:'number',  key: 'decimal', caption:'Decimal', dataType:'string'},
    {name:'email', caption:'Email', dataType:'email'},
    {name:'number', key: 'integer', caption:'Integer', dataType:'integer'},
    {name:'number', caption:'Number', dataType:'number'},
    {name:'phonenumber', caption:'Phone Number', dataType:'phonenumber'},
  ]}
 data={[
  {
    string: 'test1',
    boolean: true,
    date: '2018-07-18T10:09:30.662Z',
    email: 'test1@test.com',
    number: 10.5,
    phonenumber: '072343456',
    icon: 'Bug',
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
  },
  {
    string: 'test2',
    boolean: false,
    date: '2018-05-17T09:03:20.662Z',
    email: 'test2@test.com',
    number: 5.75,
    phonenumber: '0713432494',
    icon: 'Castle',
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
  },
  {
    string: 'test3',
    boolean: true,
    date: '2017-09-16T07:03:10.662Z',
    email: 'test3@test.com',
    number: 7,
    phonenumber: '0779236287',
    icon: 'Diamond',
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
  },
]}
/>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Table
  columns={[
    {name:'image', caption:'Image', dataType:'image', cellInnerStyle: { height: '40px' }},
    {name:'icon', caption:'Icon', dataType:'icon'},
    {name:'string', caption:'String', dataType:'string'},
    {name:'boolean', caption:'Boolean', dataType:'boolean'},
    {name:'currency', field: 'number', caption:'Currency', dataType:'currency'},
    {name:'date', caption:'Date', dataType:'date'},
    {name:'datetime', field: 'date', caption:'Date & Time', dataType:'datetime'},
    {name:'decimal',  field: 'number', caption:'Decimal', dataType:'string'},
    {name:'email', caption:'Email', dataType:'email'},
    {name:'integer', field: 'number', caption:'Integer', dataType:'integer'},
    {name:'number', field: 'number', caption:'Number', dataType:'number'},
    {name:'phonenumber', caption:'Phone Number', dataType:'phonenumber'},
  ]}
 data={[
  {
    string: 'test1',
    boolean: true,
    date: '2018-07-18T10:09:30.662Z',
    email: 'test1@test.com',
    number: 10.5,
    phonenumber: '072343456',
    icon: 'Bug',
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
  },
  {
    string: 'test2',
    boolean: false,
    date: '2018-05-17T09:03:20.662Z',
    email: 'test2@test.com',
    number: 5.75,
    phonenumber: '0713432494',
    icon: 'Castle',
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
  },
  {
    string: 'test3',
    boolean: true,
    date: '2017-09-16T07:03:10.662Z',
    email: 'test3@test.com',
    number: 7,
    phonenumber: '0779236287',
    icon: 'Diamond',
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
  },
]}
/>`,
  },
};

const LargeTableStory: Story = {
  title: 'Large table',
  description: 'A table with lots of rows',
  coreComponent: {
    html: `<tag-table height='300px'>
  <tag-table-column name='item' caption='Item'>
  </tag-table-column>
  <tag-table-column name='score' caption='Score''>
  </tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
var data = [];
for (var i = 0; i < 1000; i++) {
  data.push({ item: 'Item ' + (i + 1), score: i + 1 });
}
tagTable.data = data;
`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
    const data = [];
    for (var i = 0; i < 1000; i++) {
      data.push({ item: 'Item ' + (i + 1), score: i + 1 });
    }
    return (
      <TagTable
        height='300px'
        columns={[
          {name:'item', caption:'Item'},
          {name:'score', caption:'Score'}
        ]}
        data={data}
      />
    )
  };`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
    const data = [];
    for (var i = 0; i < 1000; i++) {
      data.push({ item: 'Item ' + (i + 1), score: i + 1 });
    }
    return (
      <Tag3Table
        height='300px'
        columns={[
          {name:'item', caption:'Item'},
          {name:'score', caption:'Score'}
        ]}
        data={data}
      />
    )
  };`,
  },
};

const FormattingStory: Story = {
  title: 'Formatting',
  description: 'A table that has a numerical column formatted',
  coreComponent: {
    html: `<tag-table>
  <tag-table-column
    name='number'
    caption='Raw number'>
  </tag-table-column>
  <tag-table-column
    name='number'
    caption='Padded to 4 chars'
    data-type='integer'
    formatting-options='{"minimumIntegerDigits":4,"useGrouping":false}'
    cell-style='{"text-align": "left"}'
    header-column-style='{"text-align": "left"}'>
  </tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [
  {
    number: 10,
  },
  {
    number: 5,
  },
  {
    number: 712,
  },
  {
    number: 134,
  }
];
`,
  },
  reactWrapper: {
    jsx: `<TagTable
  columns={[
    {
      name:'number',
      caption:'Raw number'
    },
    {
      name:'number',
      key:'formattedNumber',
      caption:'Padded to 4 chars',
      dataType: 'integer',
      formattingOptions: '{"minimumIntegerDigits":4,"useGrouping":false}',
      cellStyle: {textAlign: "left"},
      headerStyle: {textAlign: "left"},
    }
  ]}
  data={[
    {
      number: 10,
    },
    {
      number: 5,
    },
    {
      number: 712,
    },
    {
      number: 134,
    }
  ]}
/>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Table
  columns={[
    {
      name:'number',
      field: 'number',
      caption:'Raw number'
    },
    {
      name:'formattedNumber',
      field: 'number',
      key:'formattedNumber',
      caption:'Padded to 4 chars',
      dataType: 'integer',
      formattingOptions: '{"minimumIntegerDigits":4,"useGrouping":false}',
      cellStyle: {textAlign: "left"},
      headerStyle: {textAlign: "left"},
    }
  ]}
  data={[
    {
      number: 10,
    },
    {
      number: 5,
    },
    {
      number: 712,
    },
    {
      number: 134,
    }
  ]}
/>`,
  },
};

const HighlightedRowsStory: Story = {
  title: 'Highlighted rows',
  description: 'A table that has important rows highlighted',
  coreComponent: {
    html: `<tag-table row-style-field='highlight'>
  <tag-table-column name='name' caption='Name'></tag-table-column>
  <tag-table-column name='club' caption='Club'></tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [
  {
    name: 'Jordan Pickford',
    club: 'Everton',
  },
  {
    name: 'Kyle Walker',
    club: 'Man City',
  },
  {
    name: 'John Stones',
    club: 'Man City',
    highlight: '{"background-color": "#efcc89"}',
  },
  {
    name: 'Harry Maguire',
    club: 'Man Utd',
  },
  {
    name: 'Luke Shaw',
    club: 'Man Utd',
  },
  {
    name: 'Jordan Henderson',
    club: 'Liverpool',
    highlight: '{"background-color": "#b2cfbb"}',
  },
];
`,
  },
  reactWrapper: {
    jsx: `<TagTable
  rowStyleField='highlight'
  columns={[
    {
      name:'name',
      caption:'Name'
    },
    {
      name:'club',
      caption:'Club'
    },
  ]}
  data={[
    {
      name: 'Jordan Pickford',
      club: 'Everton',
    },
    {
      name: 'Kyle Walker',
      club: 'Man City',
    },
    {
      name: 'John Stones',
      club: 'Man City',
      highlight: '{"backgroundColor": "#efcc89"}',
    },
    {
      name: 'Harry Maguire',
      club: 'Man Utd',
    },
    {
      name: 'Luke Shaw',
      club: 'Man Utd',
    },
    {
      name: 'Jordan Henderson',
      club: 'Liverpool',
      highlight: '{"backgroundColor": "#b2cfbb"}',
    },
  ]}
/>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Table
  rowStyleField='highlight'
  columns={[
    {
      name:'name',
      caption:'Name'
    },
    {
      name:'club',
      caption:'Club'
    },
  ]}
  data={[
    {
      name: 'Jordan Pickford',
      club: 'Everton',
    },
    {
      name: 'Kyle Walker',
      club: 'Man City',
    },
    {
      name: 'John Stones',
      club: 'Man City',
      highlight: '{"backgroundColor": "#efcc89"}',
    },
    {
      name: 'Harry Maguire',
      club: 'Man Utd',
    },
    {
      name: 'Luke Shaw',
      club: 'Man Utd',
    },
    {
      name: 'Jordan Henderson',
      club: 'Liverpool',
      highlight: '{"backgroundColor": "#b2cfbb"}',
    },
  ]}
/>`,
  },
};

const HighlightedCellsStory: Story = {
  title: 'Highlighted cells',
  description: 'A table that has important cells highlighted',
  coreComponent: {
    html: `<tag-table>
  <tag-table-column name='name' caption='Name'></tag-table-column>
  <tag-table-column
    name='form'
    caption='Form'
    cell-style-field='highlight'
    cell-inner-style-field='highlightText'>
  </tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [
  {
    name: 'Jordan Pickford',
    form: 'poor',
    highlight: '{"background-color": "#efcc89"}',
    highlightText: '{"color": "#e5173f"}',
  },
  {
    name: 'Kyle Walker',
    form: 'normal',
  },
  {
    name: 'John Stones',
    form: 'poor',
    highlight: '{"background-color": "#efcc89"}',
    highlightText: '{"color": "#e5173f"}',
  },
  {
    name: 'Harry Maguire',
    form: 'good',
    highlight: '{"background-color": "#b2cfbb"}',
  },
  {
    name: 'Luke Shaw',
    form: 'normal',
  },
  {
    name: 'Jordan Henderson',
    form: 'normal',
  },
];
`,
  },
  reactWrapper: {
    jsx: `<TagTable
  columns={[
    {
      name:'name',
      caption:'Name'
    },
    {
      name:'form',
      caption:'Form',
      cellStyleField:'highlight',
      cellInnerStyleField:'highlightText'
    },
  ]}
  data={[
    {
      name: 'Jordan Pickford',
      form: 'poor',
      highlight: '{"backgroundColor": "#efcc89"}',
      highlightText: '{"color": "#e5173f"}',
    },
    {
      name: 'Kyle Walker',
      form: 'normal',
    },
    {
      name: 'John Stones',
      form: 'poor',
      highlight: '{"backgroundColor": "#efcc89"}',
      highlightText: '{"color": "#e5173f"}',
    },
    {
      name: 'Harry Maguire',
      form: 'good',
      highlight: '{"backgroundColor": "#b2cfbb"}',
    },
    {
      name: 'Luke Shaw',
      form: 'normal',
    },
    {
      name: 'Jordan Henderson',
      form: 'normal',
    },
  ]}
/>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Table
  columns={[
    {
      name:'name',
      caption:'Name'
    },
    {
      name:'form',
      caption:'Form',
      cellStyleField:'highlight',
      cellInnerStyleField:'highlightText'
    },
  ]}
  data={[
    {
      name: 'Jordan Pickford',
      form: 'poor',
      highlight: '{"backgroundColor": "#efcc89"}',
      highlightText: '{"color": "#e5173f"}',
    },
    {
      name: 'Kyle Walker',
      form: 'normal',
    },
    {
      name: 'John Stones',
      form: 'poor',
      highlight: '{"backgroundColor": "#efcc89"}',
      highlightText: '{"color": "#e5173f"}',
    },
    {
      name: 'Harry Maguire',
      form: 'good',
      highlight: '{"backgroundColor": "#b2cfbb"}',
    },
    {
      name: 'Luke Shaw',
      form: 'normal',
    },
    {
      name: 'Jordan Henderson',
      form: 'normal',
    },
  ]}
/>`,
  },
};

const ButtonStory: Story = {
  title: 'Button',
  description: 'A table that has a button in each row',
  coreComponent: {
    html: `<tag-table button='Play' button-icon='Football'>
  <tag-table-column name='name' caption='Name'></tag-table-column>
  <tag-table-column name='club' caption='Club'></tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [
  {
    name: 'Jordan Pickford',
    club: 'Everton',
  },
  {
    name: 'Kyle Walker',
    club: 'Man City',
  },
  {
    name: 'John Stones',
    club: 'Man City',
  },
  {
    name: 'Harry Maguire',
    club: 'Man Utd',
  },
  {
    name: 'Luke Shaw',
    club: 'Man Utd',
  },
  {
    name: 'Jordan Henderson',
    club: 'Liverpool',
  },
];
`,
  },
  reactWrapper: {
    jsx: `<TagTable
  button='Play'
  buttonIcon='Football'
  columns={[
    { name:'name', caption:'Name' },
    { name:'club', caption:'Club' },
  ]}
  data={[
    {
      name: 'Jordan Pickford',
      club: 'Everton',
    },
    {
      name: 'Kyle Walker',
      club: 'Man City',
    },
    {
      name: 'John Stones',
      club: 'Man City',
    },
    {
      name: 'Harry Maguire',
      club: 'Man Utd',
    },
    {
      name: 'Luke Shaw',
      club: 'Man Utd',
    },
    {
      name: 'Jordan Henderson',
      club: 'Liverpool',
    },
  ]}
/>`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
  const data = [
    {
      name: 'Jordan Pickford',
      club: 'Everton',
    },
    {
      name: 'Kyle Walker',
      club: 'Man City',
    },
    {
      name: 'John Stones',
      club: 'Man City',
    },
    {
      name: 'Harry Maguire',
      club: 'Man Utd',
    },
    {
      name: 'Luke Shaw',
      club: 'Man Utd',
    },
    {
      name: 'Jordan Henderson',
      club: 'Liverpool',
    },
  ];
  const [playing, setPlaying] = React.useState([]);
  return (
    <Tag3Table
      button='Play'
      buttonIcon='Football'
      buttonGetStyle={({ row }) => {
        return {display: playing.indexOf(row.name) > -1 ? 'none' : undefined}
      }}
      columns={[
        { name:'name', caption:'Name' },
        { name:'club', caption:'Club' },
        { name:'playing', caption:'Playing', dataType:'boolean' },
      ]}
      data={data.map(({name, club}) => ({ name, club, playing: playing.indexOf(name) > -1 }))}
      onRowButtonClick={(e) => setPlaying(p => p.concat(e.detail.row.name))}
    />
  )
}`,
  },
};

const SelectableStory: Story = {
  title: 'Selectable',
  description: 'A table where you can select a single row',
  coreComponent: {
    html: `<tag-table selectable >
  <tag-table-column name='name' caption='Name'></tag-table-column>
  <tag-table-column name='club' caption='Club'></tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [
  {
    name: 'Jordan Pickford',
    club: 'Everton',
  },
  {
    name: 'Kyle Walker',
    club: 'Man City',
  },
  {
    name: 'John Stones',
    club: 'Man City',
  },
  {
    name: 'Harry Maguire',
    club: 'Man Utd',
  },
  {
    name: 'Luke Shaw',
    club: 'Man Utd',
  },
  {
    name: 'Jordan Henderson',
    club: 'Liverpool',
  },
];
`,
  },
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
  const [selected, setSelected] = React.useState();
  return (
    <>
      <TagText text={selected ? 'Selected player: ' + selected.name : 'No player selected'} />
      <TagTable
        selectable
        onRowSelected={e => setSelected(e.detail.row)}
        columns={[
          { name:'name', caption:'Name' },
          { name:'club', caption:'Club' },
        ]}
        data={[
          {
            name: 'Jordan Pickford',
            club: 'Everton',
          },
          {
            name: 'Kyle Walker',
            club: 'Man City',
          },
          {
            name: 'John Stones',
            club: 'Man City',
          },
          {
            name: 'Harry Maguire',
            club: 'Man Utd',
          },
          {
            name: 'Luke Shaw',
            club: 'Man Utd',
          },
          {
            name: 'Jordan Henderson',
            club: 'Liverpool',
          },
        ]}
      />
    </>
  )
}`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
  const [selected, setSelected] = React.useState();
  return (
    <>
      <Tag3Text text={selected ? 'Selected player: ' + selected.name : 'No player selected'} />
      <Tag3Table
        selectable
        onRowSelected={e => setSelected(e.detail.row)}
        columns={[
          { name:'name', caption:'Name' },
          { name:'club', caption:'Club' },
        ]}
        data={[
          {
            name: 'Jordan Pickford',
            club: 'Everton',
          },
          {
            name: 'Kyle Walker',
            club: 'Man City',
          },
          {
            name: 'John Stones',
            club: 'Man City',
          },
          {
            name: 'Harry Maguire',
            club: 'Man Utd',
          },
          {
            name: 'Luke Shaw',
            club: 'Man Utd',
          },
          {
            name: 'Jordan Henderson',
            club: 'Liverpool',
          },
        ]}
      />
    </>
  )
}`,
  },
};

const SelectableControlledStory: Story = {
  title: 'Selectable controlled',
  description: 'A table where the selected row is controlled by state',
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
  const [selectedRow, setSelectedRow] = React.useState('John Stones');
  return (
    <>
      <div style={{marginBottom: "10px"}}>
        <Tag3SimpleButton onButtonClick={() => setSelectedRow("Harry Maguire")}>Select Harry</Tag3SimpleButton>
        <Tag3SimpleButton onButtonClick={() => setSelectedRow(undefined)} style={{marginLeft: "10px"}}>De-select</Tag3SimpleButton>
      </div>
      <Tag3Table
        selectable
        selectedRow={selectedRow}
        onRowSelected={e => setSelectedRow(e.detail.row.name)}
        rowKeyField="name"
        columns={[
          { name:'name', caption:'Name' },
          { name:'club', caption:'Club' },
        ]}
        data={[
          {
            name: 'Jordan Pickford',
            club: 'Everton',
          },
          {
            name: 'Kyle Walker',
            club: 'Man City',
          },
          {
            name: 'John Stones',
            club: 'Man City',
          },
          {
            name: 'Harry Maguire',
            club: 'Man Utd',
          },
          {
            name: 'Luke Shaw',
            club: 'Man Utd',
          },
          {
            name: 'Jordan Henderson',
            club: 'Liverpool',
          },
        ]}
      />
    </>
  )
}`,
  },
};

const multiCheckStoryKnobs: Knobs = {
  multiCheckAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
    delimiter: '\n  ',
  },
  multiCheckAlign: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'left', 'right'],
    delimiter: '\n  ',
  },
  multiCheckSize: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'normal', 'large'],
    delimiter: '\n  ',
  },
  multiCheckRounded: { default: false, editor: 'checkbox', delimiter: '\n  ' },
  multiCheckSuppressSelectAll: { default: false, editor: 'checkbox', delimiter: '\n  ' },
};
const MultiCheckStory: Story = {
  title: 'Multi-check',
  description: 'A table where you can select multiple rows',
  coreComponent: {
    html: `<tag-table multi-check{{...knobs}}>
  <tag-table-column name='name' caption='Name'></tag-table-column>
  <tag-table-column name='club' caption='Club'></tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [
  {
    name: 'Jordan Pickford',
    club: 'Everton',
  },
  {
    name: 'Kyle Walker',
    club: 'Man City',
  },
  {
    name: 'John Stones',
    club: 'Man City',
  },
  {
    name: 'Harry Maguire',
    club: 'Man Utd',
  },
  {
    name: 'Luke Shaw',
    club: 'Man Utd',
  },
  {
    name: 'Jordan Henderson',
    club: 'Liverpool',
  },
];
`,
    knobs: multiCheckStoryKnobs,
  },
  reactWrapper: {
    jsx: `<TagTable
  multiCheck{{...knobs}}
  columns={[
    { name:'name', caption:'Name' },
    { name:'club', caption:'Club' },
  ]}
  data={[
    {
      name: 'Jordan Pickford',
      club: 'Everton',
    },
    {
      name: 'Kyle Walker',
      club: 'Man City',
    },
    {
      name: 'John Stones',
      club: 'Man City',
    },
    {
      name: 'Harry Maguire',
      club: 'Man Utd',
    },
    {
      name: 'Luke Shaw',
      club: 'Man Utd',
    },
    {
      name: 'Jordan Henderson',
      club: 'Liverpool',
    },
  ]}
/>`,
    knobs: multiCheckStoryKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
  const [selectedRows, setSelectedRows] = React.useState([{
    name: 'John Stones',
    club: 'Man City',
  }]);
  return (
    <>
      <Tag3P>Selected: {selectedRows.map(r => r.name).join(", ")}</Tag3P>
      <Tag3Table
        rowKeyField="name"
        multiCheck{{...knobs}}
        multiCheckDefaultRowKeysChecked={["John Stones"]}
        onRowsChecked={e => setSelectedRows(e.detail.checkedRows)}
        columns={[
          { name:'name', caption:'Name' },
          { name:'club', caption:'Club' },
        ]}
        data={[
          {
            name: 'Jordan Pickford',
            club: 'Everton',
          },
          {
            name: 'Kyle Walker',
            club: 'Man City',
          },
          {
            name: 'John Stones',
            club: 'Man City',
          },
          {
            name: 'Harry Maguire',
            club: 'Man Utd',
          },
          {
            name: 'Luke Shaw',
            club: 'Man Utd',
          },
          {
            name: 'Jordan Henderson',
            club: 'Liverpool',
          },
        ]}
      />
    </>
  )
}
`,
    knobs: multiCheckStoryKnobs,
  },
};

const MulticheckPerfStory: Story = {
  title: 'Large table with multi-check',
  description: 'A table with lots of rows and multi-check on',
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
    const [checkedCount, setCheckedCount] = React.useState(0);

    const data = [];
    for (var i = 0; i < 1000; i++) {
      data.push({ item: 'Item ' + (i + 1), score: i + 1 });
    }

    return (
      <>
        <Tag3P>{checkedCount} row(s) selected</Tag3P>
        {React.useMemo(() => <Tag3Table
          multiCheck
          height='300px'
          columns={[
            {name:'item', caption:'Item'},
            {name:'score', caption:'Score'}
          ]}
          data={data}
          onRowsChecked={e => setCheckedCount(e.detail.checkedRows.length)}
        />, [])}
      </>
    )
  };`,
  },
};

const ClientSortingStory: Story = {
  title: 'Client sorting',
  description: 'A table that has clientside sorting enabled',
  coreComponent: {
    html: `<tag-table>
  <tag-table-column name='name' caption='Name' sortable default-sort-direction="ascending"></tag-table-column>
  <tag-table-column name='dob' caption='Date of Birth' data-type='date' sortable></tag-table-column>
  <tag-table-column name='email' caption='Email' data-type='email' sortable></tag-table-column>
  <tag-table-column name='phone' caption='Phonenumber' data-type='phonenumber' sortable></tag-table-column>
  <tag-table-column name='amount' caption='Donations' data-type='currency' sortable></tag-table-column>
  <tag-table-column name='count' caption='No. Donations' data-type='integer' sortable></tag-table-column>
  <tag-table-column name='lastCommunication' caption='Last Communication' data-type='datetime' sortable></tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [
  {
    email: 'sally.tooth@test.com',
    amount: 20032,
    count: 7244
  },
  {
    name: 'Harry Peters',
    dob: '1980-01-24T00:00:00Z',
    email: 'harry.peters@test.com',
    phone: '07432 865342',
    lastCommunication: '2017-01-10T09:00:00Z'
  },
  {
    name: 'Jessica Small',
    dob: '1997-03-19T00:00:00Z',
    amount: 50,
    count: 4,
    lastCommunication: '2019-01-01T17:30:00Z'
  },
  {
    name: 'Jonny Umber',
    email: 'jonny.umber@test.com',
    amount: 7834,
    count: 2344,
    lastCommunication: '2019-09-10T09:30:00Z'
  },
  {
    name: 'Kyle Jones',
    dob: '2000-01-04T00:00:00Z',
    email: 'kyle.jones@test.com',
    phone: '07663 974324',
    amount: 1234,
    count: 45,
    lastCommunication: '2018-04-09T10:30:00Z'
  },
  {
    name: 'Scott Smith',
    dob: '1997-03-19T00:00:00Z',
    email: 'scott.smith@test.com',
    phone: '07943 432456',
    amount: 2134,
    count: 124,
    lastCommunication: '2019-09-19T15:30:00Z'
  }
];
`,
  },
  reactWrapper: {
    jsx: `<Tag3Table
    columns={[
      { name:'name', caption:'Name', sortable: true, defaultSortDirection: 'ascending' },
      { name:'dob', caption:'Date of Birth', dataType:'date', sortable: true },
      { name:'email', caption:'Email', dataType:'email', sortable: true },
      { name:'phone', caption:'Phone', dataType:'phonenumber', sortable: true },
      { name:'amount', caption:'Donations', dataType:'currency', sortable: true },
      { name:'count', caption:'No. Donations', dataType:'integer', sortable: true },
      { name:'lastCommunication', caption:'Last Communication', dataType:'datetime', sortable: true },
    ]}
    data={[
    {
      email: 'sally.tooth@test.com',
      amount: 20032,
      count: 7244
    },
    {
      name: 'Harry Peters',
      dob: '1980-01-24T00:00:00Z',
      email: 'harry.peters@test.com',
      phone: '07432 865342',
      lastCommunication: '2017-01-10T09:00:00Z'
    },
    {
      name: 'Jessica Small',
      dob: '1997-03-19T00:00:00Z',
      amount: 50,
      count: 4,
      lastCommunication: '2019-01-01T17:30:00Z'
    },
    {
      name: 'Jonny Umber',
      email: 'jonny.umber@test.com',
      amount: 7834,
      count: 2344,
      lastCommunication: '2019-09-10T09:30:00Z'
    },
    {
      name: 'Kyle Jones',
      dob: '2000-01-04T00:00:00Z',
      email: 'kyle.jones@test.com',
      phone: '07663 974324',
      amount: 1234,
      count: 45,
      lastCommunication: '2018-04-09T10:30:00Z'
    },
    {
      name: 'Scott Smith',
      dob: '1997-03-19T00:00:00Z',
      email: 'scott.smith@test.com',
      phone: '07943 432456',
      amount: 2134,
      count: 124,
      lastCommunication: '2019-09-19T15:30:00Z'
    }]}
/>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Table
    columns={[
      { name:'name', caption:'Name', sortable: true, defaultSortDirection: 'ascending' },
      { name:'dob', caption:'Date of Birth', dataType:'date', sortable: true },
      { name:'email', caption:'Email', dataType:'email', sortable: true },
      { name:'phone', caption:'Phone', dataType:'phonenumber', sortable: true },
      { name:'amount', caption:'Donations', dataType:'currency', sortable: true },
      { name:'count', caption:'No. Donations', dataType:'integer', sortable: true },
      { name:'lastCommunication', caption:'Last Communication', dataType:'datetime', sortable: true },
    ]}
    data={[
    {
      email: 'sally.tooth@test.com',
      amount: 20032,
      count: 7244
    },
    {
      name: 'Harry Peters',
      dob: '1980-01-24T00:00:00Z',
      email: 'harry.peters@test.com',
      phone: '07432 865342',
      lastCommunication: '2017-01-10T09:00:00Z'
    },
    {
      name: 'Jessica Small',
      dob: '1997-03-19T00:00:00Z',
      amount: 50,
      count: 4,
      lastCommunication: '2019-01-01T17:30:00Z'
    },
    {
      name: 'Jonny Umber',
      email: 'jonny.umber@test.com',
      amount: 7834,
      count: 2344,
      lastCommunication: '2019-09-10T09:30:00Z'
    },
    {
      name: 'Kyle Jones',
      dob: '2000-01-04T00:00:00Z',
      email: 'kyle.jones@test.com',
      phone: '07663 974324',
      amount: 1234,
      count: 45,
      lastCommunication: '2018-04-09T10:30:00Z'
    },
    {
      name: 'Scott Smith',
      dob: '1997-03-19T00:00:00Z',
      email: 'scott.smith@test.com',
      phone: '07943 432456',
      amount: 2134,
      count: 124,
      lastCommunication: '2019-09-19T15:30:00Z'
    }]}
/>`,
  },
};

const externalSortingStory: Story = {
  title: 'External sorting',
  description: 'A table that is sorted externally',
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
  const data = [
    {
      category: 'B',
      count: 3
    },
    {
      category: 'A',
      count: 1
    },
    {
      category: 'C',
      count: 2
    }
  ];
  const sortedCategoryData = [
    {
      category: 'A',
      count: 1
    },
    {
      category: 'B',
      count: 3
    },
    {
      category: 'C',
      count: 2
    }
  ];
  const sortedCountdata = [
    {
      category: 'A',
      count: 1
    },
    {
      category: 'C',
      count: 2
    },
    {
      category: 'B',
      count: 3
    },
  ];
  const columns = [
    { name:'category', caption:'Category' },
    { name:'count', caption:'Count', dataType:'integer' }
  ];
  const [tableData, setTableData] = React.useState(data);
  const [tableColumns, setTableColumns] = React.useState(columns);
  const [order, setOrder] = React.useState(undefined);

  const handleOrderChange = (e) => {
    const newColumns = columns.map(c => {
      const newCol = {...c};
      if (newCol.name === e.detail.value) {
        newCol.defaultSortDirection = "ascending";
      }
      return newCol;
    });
    setTableColumns(newColumns);
    if (e.detail.value === "category") {
      setTableData(sortedCategoryData);
    } else if (e.detail.value === "count") {
      setTableData(sortedCountdata);
    } else {
      setTableData(data);
    }
    setOrder(e.detail.value);
  }

  return (
    <div>
      <div style={{width: "200px", marginLeft: "auto"}}>
        <TagEditField
          label="Select table order"
          labelPosition="left"
          editor="combobox"
          options={[
            {label: 'Category', value: "category"},
            {label: 'Count', value: "count"}
          ]}
          value={order}
          onValueChange={handleOrderChange}
        />
      </div>
      <TagTable
        columns={tableColumns}
        data={tableData}
      />
    </div>
  )
};`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
  const data = [
    {
      category: 'B',
      count: 3
    },
    {
      category: 'A',
      count: 1
    },
    {
      category: 'C',
      count: 2
    }
  ];
  const sortedCategoryData = [
    {
      category: 'A',
      count: 1
    },
    {
      category: 'B',
      count: 3
    },
    {
      category: 'C',
      count: 2
    }
  ];
  const sortedCountdata = [
    {
      category: 'A',
      count: 1
    },
    {
      category: 'C',
      count: 2
    },
    {
      category: 'B',
      count: 3
    },
  ];
  const columns = [
    { name:'category', caption:'Category' },
    { name:'count', caption:'Count', dataType:'integer' }
  ];
  const [tableData, setTableData] = React.useState(data);
  const [tableColumns, setTableColumns] = React.useState(columns);
  const [order, setOrder] = React.useState(undefined);

  const handleOrderChange = (e) => {
    const newColumns = columns.map(c => {
      const newCol = {...c};
      if (newCol.name === e.detail.value) {
        newCol.defaultSortDirection = "ascending";
      }
      return newCol;
    });
    setTableColumns(newColumns);
    if (e.detail.value === "category") {
      setTableData(sortedCategoryData);
    } else if (e.detail.value === "count") {
      setTableData(sortedCountdata);
    } else {
      setTableData(data);
    }
    setOrder(e.detail.value);
  }

  return (
    <div>
      <div style={{width: "200px", marginLeft: "auto"}}>
        <TagEditField
          label="Select table order"
          labelPosition="left"
          editor="combobox"
          options={[
            {label: 'Category', value: "category"},
            {label: 'Count', value: "count"}
          ]}
          value={order}
          onValueChange={handleOrderChange}
        />
      </div>
      <Tag3Table
        columns={tableColumns}
        data={tableData}
      />
    </div>
  )
};`,
  },
};

const CustomSortingStory: Story = {
  title: 'Custom sorting',
  description:
    'A table that has custom sorting which would typically be used for a server side sort',
  coreComponent: {
    html: `<tag-table>
  <tag-table-column name='urgency' caption='Urgency' sortable></tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [{ urgency: 'Low' }, { urgency: 'High' }, { urgency: 'Medium' }];
tagTable.sort = function (columnName, columnSortDirection, data) {
  var newColumnDirection = columnSortDirection
      ? columnSortDirection === 'ascending'
        ? 'descending'
        : 'ascending'
      : 'ascending';
  var sortedData = newColumnDirection === 'ascending'
    ?  [{ urgency: 'Low' }, { urgency: 'Medium' }, { urgency: 'High' }]
    :  [{ urgency: 'High' }, { urgency: 'Medium' }, { urgency: 'Low' }]
  return {
    columnSortDirection: newColumnDirection,
    data: sortedData,
  }
}
`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
    const [data, setData] = React.useState([{ urgency: 'Low' }, { urgency: 'High' }, { urgency: 'Medium' }]);
    return (
      <TagTable
        columns={[{ name:'urgency', caption:'Urgency', sortable: true }]}
        data={data}
        sort={(columnName, columnSortDirection, data) => {
          const newColumnDirection = columnSortDirection
            ? columnSortDirection === 'ascending'
              ? 'descending'
              : 'ascending'
            : 'ascending';
          const sortedData = newColumnDirection === 'ascending'
            ?  [{ urgency: 'Low' }, { urgency: 'Medium' }, { urgency: 'High' }]
            :  [{ urgency: 'High' }, { urgency: 'Medium' }, { urgency: 'Low' }]
          return {
            columnSortDirection: newColumnDirection,
            data: sortedData,
          }
        }}
        onTableSorted={(e) => setData(e.detail.data)}
      />
    )
  };`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
    const [data, setData] = React.useState([{ urgency: 'Low' }, { urgency: 'High' }, { urgency: 'Medium' }]);
    return (
      <Tag3Table
        columns={[{ name:'urgency', caption:'Urgency', sortable: true }]}
        data={data}
        onTableSorted={(e) => {
          const sortedData = e.detail.sortDirection === 'ascending'
            ?  [{ urgency: 'Low' }, { urgency: 'Medium' }, { urgency: 'High' }]
            :  [{ urgency: 'High' }, { urgency: 'Medium' }, { urgency: 'Low' }]
          setData(sortedData)
          }
        }
      />
    )
  };`,
  },
};

const HeaderAlignmentStory: Story = {
  title: 'Header alignment',
  description: 'A table that has sortable and custom aligned columns',
  coreComponent: {
    html: `
  <tag-table>
    <tag-table-column name='number' caption='Number' data-type='number' sortable alignment='left' header-column-alignment='left'></tag-table-column>
    <tag-table-column name='date' caption='Date' data-type='date' sortable alignment='center' header-column-alignment='center'></tag-table-column>
    <tag-table-column name='email' caption='Email' data-type='email' sortable alignment='center' header-column-alignment='center'></tag-table-column>
    <tag-table-column name='phonenumber' caption='Phone number' data-type='phonenumber' sortable alignment='center' header-column-alignment='center'></tag-table-column>
    <tag-table-column name='amount' caption='Currency' data-type='currency' sortable alignment='center' header-column-alignment='center'></tag-table-column>
    <tag-table-column name='string' caption='String' alignment='right' header-column-alignment='right' sortable></tag-table-column>
  </tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
    tagTable.data = [
      {
        string: 'test1',
        date: '2018-07-18T10:09:30.662Z',
        email: 'test1@test.com',
        number: 10.5,
        phonenumber: '072343456',
        amount: 2154
      },
      {
        string: 'test2',
        date: '2018-05-17T09:03:20.662Z',
        email: 'test2@test.com',
        number: 5.75,
        phonenumber: '0713432494',
        amount: 548
      },
      {
        string: 'test3',
        date: '2017-09-16T07:03:10.662Z',
        email: 'test3@test.com',
        number: 7,
        phonenumber: '0779236287',
        amount: 51235
      },
    ];
`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
    const [data, setData] = React.useState([
      {
        string: 'test1',
        date: '2018-07-18T10:09:30.662Z',
        email: 'test1@test.com',
        number: 10.5,
        phonenumber: '072343456',
        amount: 2154
      },
      {
        string: 'test2',
        date: '2018-05-17T09:03:20.662Z',
        email: 'test2@test.com',
        number: 5.75,
        phonenumber: '0713432494',
        amount: 548
      },
      {
        string: 'test3',
        date: '2017-09-16T07:03:10.662Z',
        email: 'test3@test.com',
        number: 7,
        phonenumber: '0779236287',
        amount: 51235
      },
    ]);
    return (
      <TagTable
        columns={[
          { name:'number', caption:'Number', dataType:'number', sortable: true, alignment: 'left', headerColumnAlignment: 'left' },
          { name:'date', caption:'Date', dataType:'date', sortable: true, alignment: 'center', headerColumnAlignment: 'center' },
          { name:'email', caption:'Email', dataType:'email', sortable: true, alignment: 'center', headerColumnAlignment: 'center' },
          { name:'phonenumber', caption:'Phone number', dataType:'phonenumber', sortable: true, alignment: 'center', headerColumnAlignment: 'center' },
          { name:'amount', caption:'Currency', dataType:'currency', sortable: true, alignment: 'center', headerColumnAlignment: 'center' },
          { name:'string', caption:'String', dataType:'string', sortable: true, alignment: 'right', headerColumnAlignment: 'right' },
        ]}
        data={data}
        onTableSorted={(e) => setData(e.detail.data)}
      />
    )
  };`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
    const [data, setData] = React.useState([
      {
        string: 'test1',
        date: '2018-07-18T10:09:30.662Z',
        email: 'test1@test.com',
        number: 10.5,
        phonenumber: '072343456',
        amount: 2154
      },
      {
        string: 'test2',
        date: '2018-05-17T09:03:20.662Z',
        email: 'test2@test.com',
        number: 5.75,
        phonenumber: '0713432494',
        amount: 548
      },
      {
        string: 'test3',
        date: '2017-09-16T07:03:10.662Z',
        email: 'test3@test.com',
        number: 7,
        phonenumber: '0779236287',
        amount: 51235
      },
    ]);
    return (
      <Tag3Table
        columns={[
          { name:'number', caption:'Number', dataType:'number', sortable: true, alignment: 'left', headerColumnAlignment: 'left' },
          { name:'date', caption:'Date', dataType:'date', sortable: true, alignment: 'center', headerColumnAlignment: 'center' },
          { name:'email', caption:'Email', dataType:'email', sortable: true, alignment: 'center', headerColumnAlignment: 'center' },
          { name:'phonenumber', caption:'Phone number', dataType:'phonenumber', sortable: true, alignment: 'center', headerColumnAlignment: 'center' },
          { name:'amount', caption:'Currency', dataType:'currency', sortable: true, alignment: 'center', headerColumnAlignment: 'center' },
          { name:'string', caption:'String', dataType:'string', sortable: true, alignment: 'right', headerColumnAlignment: 'right' },
        ]}
        data={data}
        onTableSorted={e => setData(e.detail.data)}
      />
    )
  };`,
  },
};

const ClientPagingStoryKnobs: Knobs = {
  pagerAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
    delimiter: ' ',
  },
  pagerAlign: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'left', 'right', 'center'],
    delimiter: ' ',
  },
  pagerShowFirstLast: {
    default: false,
    editor: 'checkbox',
    delimiter: ' ',
  },
};
const ClientPagingStory: Story = {
  title: 'Client paging',
  description: 'A table that has clientside paging',
  coreComponent: {
    html: `<tag-table height="200px"{{...knobs}}>
  <tag-table-column name='name' caption='Name'></tag-table-column>
  <tag-table-column name='club' caption='Club'></tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
var players = [
  { name: 'Jordan Pickford', club: 'Everton' },
  { name: 'Kyle Walker', club: 'Man City' },
  { name: 'John Stones', club: 'Man City' },
  { name: 'Harry Maguire', club: 'Man Utd' },
  { name: 'Luke Shaw', club: 'Man Utd' },
  { name: 'Jordan Henderson', club: 'Liverpool' },
  { name: 'Harry Kane', club: 'Tottenham' },
  { name: 'Raheem Sterling', club: 'Man City' },
  { name: 'Mason Mount', club: 'Chelsea' },
  { name: 'Jack Grealish', club: 'Aston Villa' },
  { name: 'Marcus Rashford', club: 'Man Utd' },
  { name: 'Declan Rice', club: 'West Ham' },
  { name: 'Luke Shaw', club: 'Man Utd' },
];
var pageSize = 5;

function getData(page) {
  var pageOfData = players.slice((page - 1) * pageSize, page * pageSize);

  var recordCount = players.length;
  return {
    recordCount: recordCount,
    pageCount: Math.ceil(recordCount / pageSize),
    data: pageOfData,
  };
}

function setData(page) {
  var dataResult = getData(page || tagTable.page);
  tagTable.setData({
    page: page || tagTable.page,
    pageSize: pageSize,
    pageCount: dataResult.pageCount,
    recordCount: dataResult.recordCount,
    data: dataResult.data,
  });
}

tagTable.componentOnReady().then(function() {
  setData(1)
  tagTable.addEventListener('pageRequest', function(e) {
    setData(e.detail.page);
  });
});
`,
    knobs: ClientPagingStoryKnobs,
  },

  reactWrapper: {
    jsx: `<Example />`,
    knobs: ClientPagingStoryKnobs,
    parentJSX: `const Example = () => {
    const players = [
      { name: 'Jordan Pickford', club: 'Everton' },
      { name: 'Kyle Walker', club: 'Man City' },
      { name: 'John Stones', club: 'Man City' },
      { name: 'Harry Maguire', club: 'Man Utd' },
      { name: 'Luke Shaw', club: 'Man Utd' },
      { name: 'Jordan Henderson', club: 'Liverpool' },
      { name: 'Harry Kane', club: 'Tottenham' },
      { name: 'Raheem Sterling', club: 'Man City' },
      { name: 'Mason Mount', club: 'Chelsea' },
      { name: 'Jack Grealish', club: 'Aston Villa' },
      { name: 'Marcus Rashford', club: 'Man Utd' },
      { name: 'Declan Rice', club: 'West Ham' },
      { name: 'Luke Shaw', club: 'Man Utd' },
    ];
    const pageSize = 5;

    const [page, setPage] = React.useState(1);

    const pageOfData = players.slice((page - 1) * pageSize, page * pageSize);

    const recordCount = players.length;
    const pageCount = Math.ceil(recordCount / pageSize);

    return (
      <TagTable height="200px"{{...knobs}}
        columns={[
          { name:'name', caption:'Name' },
          { name:'club', caption:'Club' }
        ]}
        data={pageOfData}
        page={page}
        pageSize={pageSize}
        pageCount={3}
        recordCount={11}
        onPageRequest={(e) => setPage(e.detail.page)}
      />
    )
  };`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    knobs: {
      accent: {
        default: '',
        editor: 'dropdown',
        editorOptions: [''].concat(Accents),
        delimiter: ' ',
      },
      pagerAlign: {
        default: '',
        editor: 'dropdown',
        editorOptions: ['', 'left', 'right', 'center'],
        delimiter: ' ',
      },
      pagerShowFirstLast: {
        default: false,
        editor: 'checkbox',
        delimiter: ' ',
      },
    },
    parentJSX: `const Example = () => {
    const players = [
      { name: 'Jordan Pickford', club: 'Everton' },
      { name: 'Kyle Walker', club: 'Man City' },
      { name: 'John Stones', club: 'Man City' },
      { name: 'Harry Maguire', club: 'Man Utd' },
      { name: 'Luke Shaw', club: 'Man Utd' },
      { name: 'Jordan Henderson', club: 'Liverpool' },
      { name: 'Harry Kane', club: 'Tottenham' },
      { name: 'Raheem Sterling', club: 'Man City' },
      { name: 'Mason Mount', club: 'Chelsea' },
      { name: 'Jack Grealish', club: 'Aston Villa' },
      { name: 'Marcus Rashford', club: 'Man Utd' },
      { name: 'Declan Rice', club: 'West Ham' },
      { name: 'Luke Shaw', club: 'Man Utd' },
    ];
    const pageSize = 5;

    const [page, setPage] = React.useState(1);

    const pageOfData = players.slice((page - 1) * pageSize, page * pageSize);

    const recordCount = players.length;
    const pageCount = Math.ceil(recordCount / pageSize);

    return (
      <Tag3Table height="200px"{{...knobs}}
        columns={[
          { name:'name', caption:'Name' },
          { name:'club', caption:'Club' }
        ]}
        data={pageOfData}
        page={page}
        pageSize={pageSize}
        pageCount={3}
        onPageRequest={(e) => setPage(e.detail.page)}
      />
    )
  };`,
  },
};

const PagerSlotStoryKnobs: Knobs = {
  pagerAlign: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'left', 'right', 'center'],
  },
};
const PagerSlotStory: Story = {
  title: 'Pager slot',
  description: 'A table that has a pager and a slot',
  coreComponent: {
    html: `<tag-table{{...knobs}}>
  <tag-table-column name='name' caption='Name'></tag-table-column>
  <tag-table-column name='club' caption='Club'></tag-table-column>
  <div slot='pager' style="padding-top: 10px">
    <tag-button text='Add player'></tag-button>
  </div>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
var players = [
  { name: 'Jordan Pickford', club: 'Everton' },
  { name: 'Kyle Walker', club: 'Man City' },
  { name: 'John Stones', club: 'Man City' },
  { name: 'Harry Maguire', club: 'Man Utd' },
  { name: 'Luke Shaw', club: 'Man Utd' },
  { name: 'Jordan Henderson', club: 'Liverpool' },
  { name: 'Harry Kane', club: 'Tottenham' },
  { name: 'Raheem Sterling', club: 'Man City' },
  { name: 'Mason Mount', club: 'Chelsea' },
  { name: 'Jack Grealish', club: 'Aston Villa' },
  { name: 'Marcus Rashford', club: 'Man Utd' },
  { name: 'Declan Rice', club: 'West Ham' },
  { name: 'Luke Shaw', club: 'Man Utd' },
];
var pageSize = 5;

function getData(page) {
  var pageOfData = players.slice((page - 1) * pageSize, page * pageSize);

  var recordCount = players.length;
  return {
    recordCount: recordCount,
    pageCount: Math.ceil(recordCount / pageSize),
    data: pageOfData,
  };
}

function setData(page) {
  var dataResult = getData(page || tagTable.page);
  tagTable.setData({
    page: page || tagTable.page,
    pageSize: pageSize,
    pageCount: dataResult.pageCount,
    recordCount: dataResult.recordCount,
    data: dataResult.data,
  });
}

tagTable.componentOnReady().then(function() {
  setData(1)
  tagTable.addEventListener('pageRequest', function(e) {
    setData(e.detail.page);
  });
});
`,
    knobs: PagerSlotStoryKnobs,
  },

  reactWrapper: {
    jsx: `<Example />`,
    knobs: PagerSlotStoryKnobs,
    parentJSX: `const Example = () => {
    const players = [
      { name: 'Jordan Pickford', club: 'Everton' },
      { name: 'Kyle Walker', club: 'Man City' },
      { name: 'John Stones', club: 'Man City' },
      { name: 'Harry Maguire', club: 'Man Utd' },
      { name: 'Luke Shaw', club: 'Man Utd' },
      { name: 'Jordan Henderson', club: 'Liverpool' },
      { name: 'Harry Kane', club: 'Tottenham' },
      { name: 'Raheem Sterling', club: 'Man City' },
      { name: 'Mason Mount', club: 'Chelsea' },
      { name: 'Jack Grealish', club: 'Aston Villa' },
      { name: 'Marcus Rashford', club: 'Man Utd' },
      { name: 'Declan Rice', club: 'West Ham' },
      { name: 'Luke Shaw', club: 'Man Utd' },
    ];
    const pageSize = 5;

    const [page, setPage] = React.useState(1);

    const pageOfData = players.slice((page - 1) * pageSize, page * pageSize);

    const recordCount = players.length;
    const pageCount = Math.ceil(recordCount / pageSize);

    return (
      <TagTable height="200px"{{...knobs}}
        columns={[
          { name:'name', caption:'Name' },
          { name:'club', caption:'Club' }
        ]}
        data={pageOfData}
        renderPager={() => (
          <div style={{display: "flex", alignItems: "center"}}>
            <Tag3Span textStyle={{marginRight: "10px"}}>Showing page {page} of {pageCount}</Tag3Span>
            <Tag3Pager
              page={page}
              pageSize={pageSize}
              pageCount={3}
              onPageRequest={(e) => setPage(e.detail.page)}
              accent="access"
            />
          </div>
        )}
        onPageRequest={(e) => setPage(e.detail.page)}
      />
    )
  };`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    knobs: PagerSlotStoryKnobs,
    parentJSX: `const Example = () => {
    const players = [
      { name: 'Jordan Pickford', club: 'Everton' },
      { name: 'Kyle Walker', club: 'Man City' },
      { name: 'John Stones', club: 'Man City' },
      { name: 'Harry Maguire', club: 'Man Utd' },
      { name: 'Luke Shaw', club: 'Man Utd' },
      { name: 'Jordan Henderson', club: 'Liverpool' },
      { name: 'Harry Kane', club: 'Tottenham' },
      { name: 'Raheem Sterling', club: 'Man City' },
      { name: 'Mason Mount', club: 'Chelsea' },
      { name: 'Jack Grealish', club: 'Aston Villa' },
      { name: 'Marcus Rashford', club: 'Man Utd' },
      { name: 'Declan Rice', club: 'West Ham' },
      { name: 'Luke Shaw', club: 'Man Utd' },
    ];
    const pageSize = 5;

    const [page, setPage] = React.useState(1);

    const pageOfData = players.slice((page - 1) * pageSize, page * pageSize);

    const recordCount = players.length;
    const pageCount = Math.ceil(recordCount / pageSize);

    return (
      <Tag3Table height="200px"{{...knobs}}
        columns={[
          { name:'name', caption:'Name' },
          { name:'club', caption:'Club' }
        ]}
        data={pageOfData}
        renderPager={() => (
          <div style={{display: "flex", alignItems: "center"}}>
            <Tag3Span textStyle={{marginRight: "10px"}}>Showing page {page} of {pageCount}</Tag3Span>
            <Tag3Pager
              page={page}
              pageSize={pageSize}
              pageCount={3}
              onPageRequest={(e) => setPage(e.detail.page)}
              accent="access"
            />
          </div>
        )}
      />
    )
  };`,
  },
};

const ColumnPickerStory: Story = {
  title: 'Column picker',
  description:
    'A table that has a column picker to adjust what columns are shown and the order they appear in',
  coreComponent: {
    html: `<tag-table name='column-picker-story-html' show-column-picker cache-columns>
  <tag-table-column name='name' caption='Name'></tag-table-column>
  <tag-table-column name='dob' caption='Date of Birth' data-type='date'></tag-table-column>
  <tag-table-column name='email' caption='Email' data-type='email'></tag-table-column>
  <tag-table-column name='phone' caption='Phonenumber' data-type='phonenumber'></tag-table-column>
  <tag-table-column name='amount' caption='Donations' data-type='currency'></tag-table-column>
  <tag-table-column name='count' caption='No. Donations' data-type='integer'></tag-table-column>
  <tag-table-column name='lastCommunication' caption='Last Communication' data-type='datetime'></tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [
  {
    name: 'Scott Smith',
    dob: '1997-03-19T00:00:00Z',
    email: 'scott.smith@test.com',
    phone: '07943 432456',
    amount: 2134,
    count: 124,
    lastCommunication: '2019-09-19T15:30:00Z'
  },
  {
    name: 'Kyle Jones',
    dob: '2000-01-04T00:00:00Z',
    email: 'kyle.jones@test.com',
    phone: '07663 974324',
    amount: 1234,
    count: 45,
    lastCommunication: '2018-04-09T10:30:00Z'
  },
  {
    name: 'Jonny Umber',
    email: 'jonny.umber@test.com',
    amount: 7834,
    count: 2344,
    lastCommunication: '2019-09-10T09:30:00Z'
  },
  {
    name: 'Harry Peters',
    dob: '1980-01-24T00:00:00Z',
    email: 'harry.peters@test.com',
    phone: '07432 865342',
    amount: 974,
    count: 31,
    lastCommunication: '2016-09-10T09:00:00Z'
  }
];
`,
  },
  reactWrapper: {
    jsx: `<TagTable name='column-picker-story-react' showColumnPicker cacheColumns height='150px'
  columns={[
    { name:'name', caption:'Name' },
    { name:'dob', caption:'Date of Birth', dataType:'date' },
    { name:'email', caption:'Email', dataType:'email' },
    { name:'phone', caption:'Phone', dataType:'phonenumber' },
    { name:'amount', caption:'Donations', dataType:'currency' },
    { name:'count', caption:'No. Donations', dataType:'integer' },
    { name:'lastCommunication', caption:'Last Communication', dataType:'datetime' },
  ]}
  data={[
    {
      name: 'Scott Smith',
      dob: '1997-03-19T00:00:00Z',
      email: 'scott.smith@test.com',
      phone: '07943 432456',
      amount: 2134,
      count: 124,
      lastCommunication: '2019-09-19T15:30:00Z'
    },
    {
      name: 'Kyle Jones',
      dob: '2000-01-04T00:00:00Z',
      email: 'kyle.jones@test.com',
      phone: '07663 974324',
      amount: 1234,
      count: 45,
      lastCommunication: '2018-04-09T10:30:00Z'
    },
    {
      name: 'Jonny Umber',
      email: 'jonny.umber@test.com',
      amount: 7834,
      count: 2344,
      lastCommunication: '2019-09-10T09:30:00Z'
    },
    {
      name: 'Harry Peters',
      dob: '1980-01-24T00:00:00Z',
      email: 'harry.peters@test.com',
      phone: '07432 865342',
      amount: 974,
      count: 31,
      lastCommunication: '2016-09-10T09:00:00Z'
    }
  ]}
/>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Table name='column-picker-story-react3' showColumnPicker {{...knobs}} multiCheck
  columns={[
    { name:'id', caption:'ID', alwaysHidden: true },
    { name:'name', caption:'Name', alwaysVisible: true },
    { name:'dob', caption:'Date of Birth', dataType:'date' },
    { name:'email', caption:'Email', dataType:'email' },
    { name:'phone', caption:'Phone', dataType:'phonenumber' },
    { name:'amount', caption:'Donations', dataType:'currency' },
    { name:'count', caption:'No. Donations', dataType:'integer' },
    { name:'lastCommunication', caption:'Last Communication', dataType:'datetime', defaultHidden: true },
  ]}
  data={[
    {
      id: 1,
      name: 'Scott Smith',
      dob: '1997-03-19T00:00:00Z',
      email: 'scott.smith@test.com',
      phone: '07943 432456',
      amount: 2134,
      count: 124,
      lastCommunication: '2019-09-19T15:30:00Z'
    },
    {
      id: 2,
      name: 'Kyle Jones',
      dob: '2000-01-04T00:00:00Z',
      email: 'kyle.jones@test.com',
      phone: '07663 974324',
      amount: 1234,
      count: 45,
      lastCommunication: '2018-04-09T10:30:00Z'
    },
    {
      id: 3,
      name: 'Jonny Umber',
      email: 'jonny.umber@test.com',
      amount: 7834,
      count: 2344,
      lastCommunication: '2019-09-10T09:30:00Z'
    },
    {
      id: 4,
      name: 'Harry Peters',
      dob: '1980-01-24T00:00:00Z',
      email: 'harry.peters@test.com',
      phone: '07432 865342',
      amount: 974,
      count: 31,
      lastCommunication: '2016-09-10T09:00:00Z'
    }
  ]}
/>`,
    knobs: {
      allowCaptionEditing: { default: true, editor: 'checkbox' },
      allowDataTypeEditing: { default: true, editor: 'checkbox' },
    },
  },
};

const AutoformattingStory: Story = {
  title: 'Auto formatting',
  description: 'A table that has its columns formatted automatically from its data',
  reactWrapper_v3: {
    jsx: `<Tag3Table name='auto-formatting-story-react' showColumnPicker allowCaptionEditing allowDataTypeEditing
  columns={[
    { name:'id', caption:'ID',dataType:'auto' },
    { name:'name', caption:'Name', dataType:'auto'},
    { name:'dob', caption:'DOB', dataType:'auto' },
    { name:'email', caption:'Email', dataType:'auto' },
    { name:'phone', caption:'Phone', dataType:'auto' },
    { name:'amount', caption:'Donations', dataType:'auto' },
    { name:'count', caption:'Count', dataType:'auto' },
  ]}
  data={[
    {
      id: 1,
      name: 'Scott Smith',
      dob: '1997-03-19T00:00:00Z',
      email: 'scott.smith@test.com',
      phone: '07943 432456',
      amount: 2134,
      count: 124
    },
    {
      id: 2,
      name: 'Kyle Jones',
      dob: '2000-01-04T00:00:00Z',
      email: 'kyle.jones@test.com',
      phone: '07663 974324',
      amount: 1234,
      count: 45
    },
    {
      id: 3,
      name: 'Jonny Umber',
      email: 'jonny.umber@test.com',
      amount: 7834,
      count: 2344
    },
    {
      id: 4,
      name: 'Harry Peters',
      dob: '1980-01-24T00:00:00Z',
      email: 'harry.peters@test.com',
      phone: '07432 865342',
      amount: 974,
      count: 31
    }
  ]}
/>`,
  },
};

const GroupingStory: Story = {
  title: 'Grouping',
  description: 'A table that has row grouping',
  reactWrapper_v3: {
    jsx: `<Tag3Table
  columns={[
    { name:'region', caption:'Region', groupBy: {on: true} },
    { name:'year', caption:'Year' },
    { name:'amount', caption:'Amount', dataType:'currency', aggregates: [{type: "sum"}] },
    { name:'count', caption:'Count', dataType:'integer', aggregates: [{type: "sum"}]  },
  ]}
  data={[
    {
      region: "Midlands",
      year: "2020",
      amount: 300,
      count: 45
    },
    {
      region: "North East",
      year: "2020",
      amount: 300,
      count: 45
    },
    {
      region: "London",
      year: "2021",
      amount: 300,
      count: 35
    },
    {
      region: "South East",
      year: "2020",
      amount: 200,
      count: 35
    },
    {
      region: "Midlands",
      year: "2021",
      amount: 500,
      count: 59
    },
    {
      region: "North West",
      year: "2020",
      amount: 200,
      count: 45
    },
    {
      region: "London",
      year: "2021",
      amount: 225,
      count: 50
    },
    {
      region: "South East",
      year: "2020",
      amount: 300,
      count: 45
    },
    {
      region: "Midlands",
      year: "2021",
      amount: 110,
      count: 15
    },
    {
      region: "North East",
      year: "2020",
      amount: 300,
      count: 45
    },
    {
      region: "London",
      year: "2021",
      amount: 300,
      count: 25
    },
    {
      region: "South West",
      year: "2020",
      amount: 300,
      count: 45
    },

  ]}
/>`,
  },
};

const MultipleGroupingStory: Story = {
  title: 'Multiple groups',
  description: 'A table that has multiple row grouping',
  reactWrapper_v3: {
    jsx: `<Tag3Table
  columns={[
    { name:'region', caption:'Region', groupBy: {on: true} },
    { name:'year', caption:'Year', groupBy: {on: true, suppressAggregates: true} },
    { name:'quarter', caption:'Quarter', groupBy: {on: true, suppressAggregates: true} },
    { name:'amount', caption:'Amount', dataType:'currency', aggregates: [{type: "sum"}] },
    { name:'count', caption:'Count', dataType:'integer', aggregates: [{type: "sum"}]  },
  ]}
  data={[
    {
      region: "Midlands",
      year: "2020",
      quarter: "Q1",
      amount: 300,
      count: 45
    },
    {
      region: "North East",
      year: "2020",
      quarter: "Q2",
      amount: 300,
      count: 45
    },
    {
      region: "London",
      year: "2021",
      quarter: "Q1",
      amount: 300,
      count: 35
    },
    {
      region: "South East",
      year: "2020",
      quarter: "Q3",
      amount: 200,
      count: 35
    },
    {
      region: "Midlands",
      year: "2021",
      quarter: "Q1",
      amount: 500,
      count: 59
    },
    {
      region: "North West",
      year: "2020",
      quarter: "Q2",
      amount: 200,
      count: 45
    },
    {
      region: "London",
      year: "2021",
      quarter: "Q2",
      amount: 225,
      count: 50
    },
    {
      region: "South East",
      year: "2020",
      quarter: "Q1",
      amount: 300,
      count: 45
    },
    {
      region: "Midlands",
      year: "2021",
      quarter: "Q1",
      amount: 110,
      count: 15
    },
    {
      region: "North East",
      year: "2020",
      quarter: "Q2",
      amount: 300,
      count: 45
    },
    {
      region: "London",
      year: "2021",
      quarter: "Q1",
      amount: 300,
      count: 25
    },
    {
      region: "South West",
      year: "2020",
      quarter: "Q1",
      amount: 300,
      count: 45
    },
    {
      region: "Midlands",
      year: "2020",
      quarter: "Q2",
      amount: 300,
      count: 45
    },
    {
      region: "North East",
      year: "2020",
      quarter: "Q1",
      amount: 300,
      count: 45
    },
    {
      region: "London",
      year: "2021",
      quarter: "Q4",
      amount: 200,
      count: 25
    },
    {
      region: "South East",
      year: "2020",
      quarter: "Q3",
      amount: 300,
      count: 45
    },
    {
      region: "Midlands",
      year: "2021",
      quarter: "Q2",
      amount: 500,
      count: 39
    },
    {
      region: "North West",
      year: "2020",
      quarter: "Q1",
      amount: 100,
      count: 15
    },
    {
      region: "London",
      year: "2021",
      quarter: "Q4",
      amount: 525,
      count: 50
    },
    {
      region: "South East",
      year: "2020",
      quarter: "Q3",
      amount: 300,
      count: 25
    },
    {
      region: "Midlands",
      year: "2021",
      quarter: "Q2",
      amount: 120,
      count: 15
    },
    {
      region: "North East",
      year: "2020",
      quarter: "Q1",
      amount: 300,
      count: 45
    },
    {
      region: "London",
      year: "2021",
      quarter: "Q2",
      amount: 300,
      count: 25
    },
    {
      region: "South West",
      year: "2020",
      quarter: "Q2",
      amount: 200,
      count: 40
    },
  ]}
/>`,
  },
};

const ColumnCachingStory: Story = {
  title: 'Column caching',
  description: 'A table that has a column picker with a custom cache',
  reactWrapper_v3: {
    parentJSX: `const Example = () => {
  const data = [
    {
      id: 1,
      name: 'Scott Smith',
      dob: '1997-03-19T00:00:00Z',
      email: 'scott.smith@test.com',
      phone: '07943 432456',
      amount: 2134,
      count: 124,
      lastCommunication: '2019-09-19T15:30:00Z'
    },
    {
      id: 2,
      name: 'Kyle Jones',
      dob: '2000-01-04T00:00:00Z',
      email: 'kyle.jones@test.com',
      phone: '07663 974324',
      amount: 1234,
      count: 45,
      lastCommunication: '2018-04-09T10:30:00Z'
    },
    {
      id: 3,
      name: 'Jonny Umber',
      email: 'jonny.umber@test.com',
      amount: 7834,
      count: 2344,
      lastCommunication: '2019-09-10T09:30:00Z'
    },
    {
      id: 4,
      name: 'Harry Peters',
      dob: '1980-01-24T00:00:00Z',
      email: 'harry.peters@test.com',
      phone: '07432 865342',
      amount: 974,
      count: 31,
      lastCommunication: '2016-09-10T09:00:00Z'
    }
  ];
  const cacheKey = "column-picker-cache-story";
  const columns = [
    { name:'id', caption:'ID', alwaysHidden: true },
    { name:'name', caption:'Name', alwaysVisible: true },
    { name:'dob', caption:'Date of Birth', dataType:'date' },
    { name:'email', caption:'Email', dataType:'email' },
    { name:'phone', caption:'Phone', dataType:'phonenumber' },
    { name:'amount', caption:'Donations', dataType:'currency' },
    { name:'count', caption:'No. Donations', dataType:'integer' },
    { name:'lastCommunication', caption:'Last Communication', dataType:'datetime', defaultHidden: true },
  ];
  const [cachedColumns, setCachedColumns] = React.useState([]);
  React.useEffect(() => {
    const columnsFromLocalStorageString = localStorage.getItem(cacheKey);
    if (columnsFromLocalStorageString === null) {
      setCachedColumns(columns);
    } else {
      try {
        const columnsFromLocalStorage = JSON.parse(columnsFromLocalStorageString).map(c => {
          const sourceColumn = columns.filter(sc => sc.name === c.name)[0];
          return {
            ...sourceColumn,
            defaultHidden: !c.visible,
            caption: c.caption,
            dataType: c.dataType,
          }
        });
        setCachedColumns(columnsFromLocalStorage);
      } catch {
        setCachedColumns(columns);
      }
    }
  }, [])

  return (
    <Tag3Table
      name={cacheKey}
      cacheColumns={false}
      showColumnPicker
      allowCaptionEditing
      allowDataTypeEditing
      columns={cachedColumns}
      saveColumnPickerColumns={cols => {
        const columnsString = JSON.stringify(cols);
        localStorage.setItem(cacheKey, columnsString);
        setCachedColumns(cols.map(c => {
          const sourceColumn = columns.filter(sc => sc.name === c.name)[0];
          return {
            ...sourceColumn,
            defaultHidden: !c.visible,
            caption: c.caption,
            dataType: c.dataType,
          }
        }))
      }}
      getResetColumns={() => columns}
      data={data}
    />
  )
}`,
    jsx: `<Example />`,
  },
};

const CustomCellRenderingStory: Story = {
  title: 'Custom cell rendering',
  description: 'A table that has cells that are custom rendered',
  reactWrapper_v3: {
    jsx: `<Tag3Table 
  columns={[
    { name:'id', caption:'ID', alwaysHidden: true },
    { name:'product', caption:'Product', renderCell: ({ row }) => (
        <div style={{padding: "5px 0px"}}>
          <Tag3TextFeature>{row.name}</Tag3TextFeature>
          <Tag3Span textStyle={{opacity: 0.6, fontSize: "12px"}}>{row.size}</Tag3Span>
          <div style={{marginTop: "8px"}}>
            <Tag3IconSvg icon="MoneyBag" accent="keppel" />
            <Tag3Span accent="keppel">Direct saving of <Tag3Format dataType="currency" text={row.saving}></Tag3Format> with this product</Tag3Span>
          </div>
        </div>
      ) 
    },
    { name:'qty', caption:'Quantity', dataType:'integer' },
    { name:'price', caption:'Best Price', dataType:'currency', alignment: "left" },
    { name:'supplier', caption:'Supplier', renderCell: ({ row }) => (
        <div style={{padding: "5px 0px"}}>
          <Tag3TextFeature textStyle={{fontSize: "14px"}}>{row.supplier}</Tag3TextFeature>
          <Tag3Span textStyle={{opacity: 0.6, fontSize: "12px"}}>{row.supplierCode}</Tag3Span>
        </div>
      ) 
    }
  ]}
  data={[
    {
      id: 1,
      name: 'Highland Spring Mineral: Water: Glass',
      size: '24x330ml',
      qty: 1,
      price: 15,
      supplier: 'Bidfood',
      supplierCode: '665GGF',
      saving: 2.5
    },
    {
      id: 2,
      name: 'Highland Spring Mineral: Water: Glass',
      size: '12x500ml',
      qty: 1,
      price: 7,
      supplier: 'Bidfood',
      supplierCode: '645LGF',
      saving: 1
    }
  ]}
/>`,
  },
};

const EditableTableStoryKnobs: Knobs = {
  inline: {
    default: true,
    editor: 'checkbox',
  },
  addButtonVerticalAlign: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'top', 'bottom'],
  },
  displayValidationMessages: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'overlay', 'flow'],
  },
};
const EditableTableStory: Story = {
  title: 'Editable table',
  description: 'An editable table',
  coreComponent: {
    html: `<tag-table add-button='Add task'{{addButtonVerticalAlign}} delete-button-icon='Delete' delete-button-rounded {{displayValidationMessages}}>
  <tag-table-column name='task' caption='Task' cell-width='120px'>
    <tag-table-column-editor max-length='20' placeholder='Enter Task' {{inline}}>
      <tag-validation rule='required'></tag-validation>
    </tag-table-column-editor>
  </tag-table-column>
  <tag-table-column name='notes' caption='Notes' cell-width='100%'>
    <tag-table-column-editor type='multilinetextbox' {{inline}}>
    </tag-table-column-editor>
  </tag-table-column>
  <tag-table-column name='priority' caption='Priority' data-type='integer' header-column-style='{"text-align": "left"}'>
    <tag-table-column-editor type='dropdown' default-value='2' {{inline}}>
      <tag-edit-field-option value='1'>Low</tag-edit-field-option>
      <tag-edit-field-option value='2'>Medium</tag-edit-field-option>
      <tag-edit-field-option value='3'>High</tag-edit-field-option>
    </tag-table-column-editor>
  </tag-table-column>
  <tag-table-column name='importance' caption='Importance' data-type='integer' header-column-style='{"text-align": "center"}'>
    <tag-table-column-editor type='toggle' default-value='2' container-style='{"align-items": "center"}'>
      <tag-edit-field-option value='1'>High</tag-edit-field-option>
      <tag-edit-field-option value='2'>Low</tag-edit-field-option>
    </tag-table-column-editor>
  </tag-table-column>
  <tag-table-column name='dueDate' caption='Due Date' cell-width='100px'>
    <tag-table-column-editor type='datepick' {{inline}}>
      <tag-validation rule='required'></tag-validation>
    </tag-table-column-editor>
  </tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [
  {
    task: 'Cut the grass',
    notes: '',
    dueDate: new Date(),
    priority: 1,
    importance: 2
  },
  {
    task: 'Do the shopping',
    notes: 'Remember to get bread',
    dueDate: new Date(),
    priority: 3,
    importance: 1
  },
];
`,
    knobs: EditableTableStoryKnobs,
  },

  reactWrapper: {
    jsx: `<Example />`,
    knobs: EditableTableStoryKnobs,
    parentJSX: `const Example = () => {
    const [data, setData] = React.useState([
      {
        task: 'Cut the grass',
        notes: '',
        dueDate: new Date(),
        priority: 1
      },
      {
        task: 'Do the shopping',
        notes: 'Remember to get bread',
        dueDate: new Date(),
        priority: 3
      },
    ]);
    return (
      <TagTable
        addButton={{
          caption: 'Add task'
        }}
        {{addButtonVerticalAlign}}
        deleteButton={{
          icon:'Delete',
          rounded: true
        }}
        columns={[
          {
            name:'task',
            caption:'Task',
            editor: {
              maxLength:'20',
              placeholder:'Enter Task',
              inline: true,
              validation: [{ rule: 'required' }],
            }
          },
          {
            name:'notes',
            caption:'Notes',
            editor: {type:'multilinetextbox', inline: true}
          },
          {
            name:'priority',
            caption:'priority',
            editor: {
              type:'dropdown',
              defaultValue:2,
              inline: true,
              options: [
                { label: 'Low', value: 1 },
                { label: 'Medium', value: 2 },
                { label: 'High', value: 3 },
              ]
            }
          },
          {
            name:'dueDate',
            caption:'Phone',
            editor: {
              type:'datepick',
              inline: true,
              validation: [{ rule: 'required' }],
            }
          },
        ]}
        data={data}
        onRowAdd={(e) => setData(e.detail.data)}
        onRowDelete={(e) => setData(e.detail.data)}
      />
    )
  }`,
  },
};

const EditableTableWithDisabledCellsStory: Story = {
  title: 'Editable table with disabled cells',
  description: 'An editable table that has cell disabling driven by its data',
  coreComponent: {
    html: `<tag-table>
  <tag-table-column name='task' caption='Task' cell-width='120px'>
    <tag-table-column-editor placeholder='Enter Task' disabled-field='done'>
    </tag-table-column-editor>
  </tag-table-column>
  <tag-table-column name='done' caption='Done' cell-width='100px'>
    <tag-table-column-editor type='checkbox'>
    </tag-table-column-editor>
  </tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [
  {
    task: 'Cut the grass',
    done: true
  },
  {
    task: 'Do the shopping',
    done: false
  },
];
tagTable.addEventListener('tableValueChange', function(e) {
  tagTable.setData(e.detail.data); // force a rerender with the updated data
});
`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
    const [data, setData] = React.useState([
      {
        task: 'Cut the grass',
        done: true
      },
      {
        task: 'Do the shopping',
        done: false
      },
    ]);
    return (
      <TagTable
        columns={[
          {
            name:'task',
            caption:'Task',
            editor: {
              placeholder:'Enter Task',
              disabledField:'done'
            }
          },
          {
            name:'done',
            caption:'Done',
            editor: {type:'checkbox'}
          }
        ]}
        data={data}
        onTableValueChange={(e) => setData(e.detail.data.slice(0))}
      />
    )
  }`,
  },
};

const EditableTableWithCustomValidationStoryKnobs: Knobs = {
  displayValidationMessages: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'overlay', 'flow'],
  },
};
const EditableTableWithCustomValidationStory: Story = {
  title: 'Editable table with custom validation',
  description: 'An editable table table with custom validation',
  coreComponent: {
    html: `<tag-table{{...knobs}}>
  <tag-table-column name='item' caption='Enter COOL' cell-width='150px'>
    <tag-table-column-editor>
      <tag-validation></tag-validation>
    </tag-table-column-editor>
  </tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [{ item: 'COOL' }, { item: '' }];
var tagValidation = tagTable
  .querySelector("tag-table-column[name='item']")
  .querySelector('tag-validation');
tagValidation.rule = function(values, fieldName, args, dataType) {
  return values[fieldName] === 'COOL' ? '' : 'You must enter COOL';
};
`,
    knobs: EditableTableWithCustomValidationStoryKnobs,
  },
  reactWrapper: {
    jsx: `<TagTable{{...knobs}}
  columns={[
    {
      caption: 'Enter COOL',
      cellWidth: '150px',
      editor: {
        validation: [
          {
            executeOn: 'blur',
            rule: (values, fieldName, args, dataType) =>
              values[fieldName] === 'COOL' ? '' : 'You must enter COOL',
          },
        ],
      },
      name: 'item',
    },
  ]}
  data={[{ item: 'COOL' },{ item: '' }]}
/>`,
    knobs: EditableTableWithCustomValidationStoryKnobs,
  },
};

const DataMappingStory: Story = {
  title: 'Data mapping',
  description: 'A table where a mapping function is applied in a column before cells are rendered',
  coreComponent: {
    html: `<tag-table>
  <tag-table-column name='item' caption='Item'></tag-table-column>
  <tag-table-column name='amount' caption='Amount' data-type="currency"></tag-table-column>
</tag-table>`,
    js: `var tagTable = document.querySelector('tag-table');
tagTable.data = [
  {
    item: 'Table',
    amount: 200,
  },
  {
    item: 'Chair',
    amount: 100,
  },
  {
    item: 'Pencil',
    amount: null,
  },
];
var amountColumn = tagTable.querySelector("tag-table-column[name='amount']");
amountColumn.componentOnReady().then(function() {
  amountColumn.valueMapper = function(value, formattedValue) {
    return value === null ? 'FREE' : formattedValue;
  };
});
`,
  },
  reactWrapper: {
    jsx: `<TagTable
  columns={[
    {
      name:'item',
      caption:'Item'
    },
    {
      name:'amount',
      caption:'Amount',
      dataType:'currency',
      valueMapper: (value, formattedValue) => value === null ? 'FREE' : formattedValue,
    }
  ]}
  data={[
    {
      item: 'Table',
      amount: 200,
    },
    {
      item: 'Chair',
      amount: 100,
    },
    {
      item: 'Pencil',
      amount: null,
    },
  ]}
/>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Table
  columns={[
    {
      name:'item',
      caption:'Item'
    },
    {
      name:'amount',
      caption:'Amount',
      dataType:'currency',
      mapCellValue: ({ value, formattedValue }) => value === null ? 'FREE' : formattedValue,
    }
  ]}
  data={[
    {
      item: 'Table',
      amount: 200,
    },
    {
      item: 'Chair',
      amount: 100,
    },
    {
      item: 'Pencil',
      amount: null,
    },
  ]}
/>`,
  },
};

const CustomHeaderAndFooterStory: Story = {
  title: 'Custom header and footer',
  description: 'A table that has custom header and footer',
  reactWrapper: {
    jsx: `<TagTable
  columns={[
    {
      name:'product',
      caption:'Product',
      renderHeader: () => <i>Product</i>,
      renderFooter: () => (
        <div style={{ textAlign: 'left' }}>
          <TagText text="Total" textStyle={{ fontWeight: 'bold' }} />
        </div>
      ),
    },
    {
      name:'delivery',
      caption:'Delivery',
      dataType:'currency',
      renderFooter: () => (
        <div style={{ textAlign: 'right' }}>
          <TagText text="£35.00" textStyle={{ fontWeight: 'bold' }} />
        </div>
      ),
    },
    {
      name:'price',
      caption:'Price',
      dataType:'currency',
      renderFooter: () => (
        <div style={{ textAlign: 'right' }}>
          <TagText text="£305.00" textStyle={{ fontWeight: 'bold' }} />
        </div>
      ),
    }
  ]}
  data={[
    {
      product: 'Table',
      delivery: 25,
      price: 210,
    },
    {
      product: 'Chair',
      delivery: 10,
      price: 90,
    },
    {
      product: 'Pencil',
      delivery: 0,
      price: 5,
    },
  ]}
/>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Table
  columns={[
    {
      name:'product',
      caption:'Product',
      renderHeader: () => <i>Product</i>,
      renderFooter: () => (
        <div style={{ textAlign: 'left' }}>
          <TagText text="Total" textStyle={{ fontWeight: 'bold' }} />
        </div>
      ),
    },
    {
      name:'delivery',
      caption:'Delivery',
      dataType:'currency',
      renderFooter: ({column, data}) => (
        <div style={{ textAlign: 'right' }}>
          <TagText text={new Intl.NumberFormat("en-gb", {style: 'currency', currency: 'GBP'}).format(data.reduce((sum, row) => sum + row[column.name], 0))} textStyle={{ fontWeight: 'bold' }} />
        </div>
      ),
    },
    {
      name:'price',
      caption:'Price',
      dataType:'currency',
      renderFooter: ({column, data}) => (
        <div style={{ textAlign: 'right' }}>
          <TagText text={new Intl.NumberFormat("en-gb", {style: 'currency', currency: 'GBP'}).format(data.reduce((sum, row) => sum + row[column.name], 0))} textStyle={{ fontWeight: 'bold' }} />
        </div>
      ),
    }
  ]}
  data={[
    {
      product: 'Table',
      delivery: 25,
      price: 210,
    },
    {
      product: 'Chair',
      delivery: 10,
      price: 90,
    },
    {
      product: 'Pencil',
      delivery: 0,
      price: 5,
    },
  ]}
/>`,
  },
};

const ValidateAllTableStory: Story = {
  title: 'Table remote validations',
  description: 'An editable table that is validated onload, after the page is refreshed',
  coreComponent: {
    html: `
  <tag-table>
    <tag-table-column name='isValid' data-type='icon'></tag-table-column>
    <tag-table-column name='no' caption='Employee No.'></tag-table-column>
    <tag-table-column name='name' caption='Name'></tag-table-column>
    <tag-table-column name='email' caption='Email Address'>
      <tag-table-column-editor>
        <tag-validation rule='email' execute-on='remote'></tag-validation>
      </tag-table-column-editor>
    </tag-table-column>
    <tag-table-column name='manager' caption='Manager Name'>
      <tag-table-column-editor>
        <tag-validation rule='required' execute-on='remote'></tag-validation>
      </tag-table-column-editor>
    </tag-table-column>
  </tag-table>
  `,
    js: `
  var tagTable = document.querySelector('tag-table');
  var data = [
    {
      no: "001071",
      name: "Eddie Smith",
      email: "eddie.smith@something.com",
      manager: "001078",
    },
    {
      isValid: 'Warning',
      no: "001079",
      name: "Liam Gordon",
      email: "l.gordon",
    },
    {
      isValid: 'Warning',
      no: "2225545",
      name: "Laura Gordon",
      email: "l.gordo",
      manager: "001078",
    },
    {
      no: "001076",
      name: "Lucas Clark",
      email: "lucas.clark@something.com",
      manager: "001078",
      containerStyle: ''
    },
    {
      no: "001075",
      name: "Vicky Fisher",
      email: "vicky.fisher@something.com",
      manager: "001078",
      containerStyle: ''
    }
  ];
  tagTable.data = data;
  setTimeout(function(){
    tagTable.validateTableRemote();
  }, 2000);
  `,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `
  const Example = () => {
    const table = React.useRef(null);
    const [data, setData] = React.useState([
      {
        no: "001071",
        name: "Eddie Smith",
        email: "eddie.smith@something.com",
        manager: "001078",
      },
      {
        isValid: 'Warning',
        no: "001079",
        name: "Liam Gordon",
        email: "l.gordon",
      },
      {
        isValid: 'Warning',
        no: "2225545",
        name: "Laura Gordon",
        email: "l.gordo",
        manager: "001078",
      },
      {
        no: "001076",
        name: "Lucas Clark",
        email: "lucas.clark@something.com",
        manager: "001078",
      },
      {
        no: "001075",
        name: "Vicky Fisher",
        email: "vicky.fisher@something.com",
        manager: "001078",
      }
    ]);
    React.useEffect(() => {
      table.current.validateTableRemote();
    }, []);
    return (
      <TagTable ref={table}
        columns={[
          {
            name:'isValid',
            dataType:'icon'
          },
          {
            name:'no',
            caption:'Employee No.',
          },
          {
            name: 'name',
            caption: 'Name'
          },
          {
            name:'email',
            caption:'Email Address',
            editor: {
              placeholder:'Enter an email address',
              validation: [
                {
                  executeOn: 'remote',
                  rule: 'email',
                }
              ],
            }
          },
          {
            name:'manager',
            caption:'Manager',
            editor: {
              placeholder:'Enter a manager',
              validation: [
                {
                  executeOn: 'remote',
                  rule: 'required',
                }
              ],
            }
          },
        ]}
        data={data}
      />
    )
  }
  `,
  },
};
const ValidateRowTableStory: Story = {
  title: 'Row/Cell remote validation',
  description:
    'An editable table that can be validated by clicking on Validate button. All cells of the row can be validated (e.g. first row of the table) or some specific cells from the row (e.g. the second row of the table). ',
  coreComponent: {
    html: `
  <tag-table button='Validate'>
    <tag-table-column name='name' caption='Validation type'></tag-table-column>
    <tag-table-column name='email' caption='Email Address'>
      <tag-table-column-editor>
        <tag-validation rule='email' execute-on='remote'></tag-validation>
      </tag-table-column-editor>
    </tag-table-column>
    <tag-table-column name='manager' caption='Manager Name'>
      <tag-table-column-editor>
        <tag-validation rule='required' execute-on='remote'></tag-validation>
      </tag-table-column-editor>
    </tag-table-column>
  </tag-table>
  `,
    js: `
  var tagTable = document.querySelector('tag-table');
  var data = [
    {
      rowIndex: 0,
      name: "Validate all cells from this row",
      email: "l.gordon",
    },
    {
      rowIndex: 1,
      name: "Validate email cell from this row",
      email: "l.gordon",
    }
  ];
  tagTable.data = data;
  tagTable.addEventListener('rowButtonClick', function(e) {
    var index = e.detail.row.rowIndex;
    if(index === 0){
      tagTable.validateTableRemote(index);
    }
    else{
      tagTable.validateTableRemote(index, 1);
    }
  })
  `,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `
  const Example = () => {
    const table = React.useRef(null);
    const [data, setData] = React.useState([
      {
        rowIndex: 0,
        name: "Validate all cells from this row",
        email: "l.gordon",
      },
      {
        rowIndex: 1,
        name: "Validate email cell from this row",
        email: "l.gordon",
      }
    ]);
    const handleButtonClick = (e) => {
      const index = e.detail.row.rowIndex;
      if(index === 0){
        table.current.validateTableRemote(index);
      }
      else{
        table.current.validateTableRemote(index, 1);
      }
    };
    return (
      <TagTable ref={table}
        button='Validate'
        onButtonClick={handleButtonClick}
        columns={[
          {
            name: 'name',
            caption: 'Validation type'
          },
          {
            name:'email',
            caption:'Email Address',
            editor: {
              placeholder:'Enter an email address',
              validation: [
                {
                  executeOn: 'remote',
                  rule: 'email',
                }
              ],
            }
          },
          {
            name:'manager',
            caption:'Manager',
            editor: {
              placeholder:'Enter a manager',
              validation: [
                {
                  executeOn: 'remote',
                  rule: 'required',
                }
              ],
            }
          },
        ]}
        data={data}
      />
    )
  }
  `,
  },
};

const RefreshStory: Story = {
  title: 'Refresh Columns',
  description:
    'Using refreshColumnsDefinition() to force a refresh of internal column definitions following a change to internal validation rules.',
  coreComponent: {
    html: `<tag-table>
  <tag-table-column name='isValid' data-type='icon' sortable></tag-table-column>
  <tag-table-column name='no' caption='Employee No.'></tag-table-column>
  <tag-table-column name='name' caption='Name'></tag-table-column>
  <tag-table-column name='email' caption='Email Address'>
    <tag-table-column-editor>
    </tag-table-column-editor>
  </tag-table-column>
  <tag-table-column name='manager' caption='Manager Name'>
    <tag-table-column-editor>
      <tag-validation execute-on='remote'></tag-validation>

    </tag-table-column-editor>
  </tag-table-column>
</tag-table>
<tag-button>Validate Table</tag-button>
<tag-button>Add Validation Rule</tag-button>
<tag-button>Refresh Table Columns Definition</tag-button>
`,
    js: `var tagTable = document.querySelector('tag-table');
var data = [
  {
    no: "001071",
    name: "Eddie Smith",
    email: "eddie.smith@something.com",
    manager: "001078",
  },
  {
    isValid: 'Warning',
    no: "001079",
    name: "Liam Gordon",
    email: "l.gordon",
  },
  {
    isValid: 'Warning',
    no: "2225545",
    name: "Laura Gordon",
    email: "l.gordo",
    manager: "001078",
  },
  {
    no: "001076",
    name: "Lucas Clark",
    email: "lucas.clark@something.com",
    manager: "001078",
    containerStyle: ''
  },
  {
    no: "001075",
    name: "Vicky Fisher",
    email: "vicky.fisher@something.com",
    manager: "001078",
    containerStyle: ''
  }
];

tagTable.data = data;

var tagValidation = tagTable.querySelector("tag-table-column[name='manager']")
.querySelector('tag-validation')

var validateTableBtn = document.querySelectorAll('tag-button')[0];
validateTableBtn.addEventListener('buttonClick', function() {
tagTable.validateTableRemote();
});

var addValidationRuleBtn = document.querySelectorAll('tag-button')[1];
addValidationRuleBtn.addEventListener('buttonClick', function() {
tagValidation.rule = function(values, fieldName, args, dataType) {
    return values[fieldName] === 'COOL' ? '' : 'You must enter "COOL"';
};
});

var refreshColumnsDefinitionBtn = document.querySelectorAll('tag-button')[2];
refreshColumnsDefinitionBtn.addEventListener('buttonClick', function() {
tagTable.refreshColumnsDefinition();
});`,
  },
};

const NoItemsStory: Story = {
  title: 'No items',
  description: `Ability to have a custom no items message in TagTable.

Initially displaying loading spinner for renderNoItems content whilst mocked data loads
then swapping to icon and 'No items available' text after 3 seconds.

'Add row' and 'Remove last row' buttons available for dynamically updating table data.`,
  reactWrapper_v3: {
    jsx: `<Example/>`,
    parentJSX: `const Example = () => {
      const [data, setData] = React.useState([]);
      const [index, setIndex] = React.useState(0);
      const [loadingData, setLoadingData] = React.useState(true);

      handleAddButtonClick = () => {
        const newData = [...data, {index: index, email: 'email' + index + '@gmail.com'}];
        setData(newData);
        const newIndex = index + 1;
        setIndex(newIndex);
      }

      handleRemoveButtonClick = () => {
        const newData = data;
        newData.splice(index - 1, 1);
        setData(newData);
        const newIndex = index - 1;
        setIndex(newIndex);
      }

      const returnNoItemsContent = () => (
         <div style={{textAlign: 'center'}}>
            <Tag3Icon icon="NoEntrySign" size={100}></Tag3Icon>
            <Tag3H3>No items available</Tag3H3>
        </div>
      );

      const returnLoadingDataSpinner = () => <TagProgressIndeterminate text='Loading' />;

      React.useEffect(() => {
          //Mocked API call which returns after 3 seconds
          setTimeout(() => {
              setLoadingData(false);
              setData([]);
          },3000)
      }, [])

      return (
        <>
          {!loadingData && (<div style={{marginBottom: '10px'}}>
            <Tag3Button accent="access" onButtonClick={handleAddButtonClick}>Add row</Tag3Button>
            <Tag3Button onButtonClick={handleRemoveButtonClick} disabled={index === 0 ? true : false}>Remove last row</Tag3Button>
          </div>)}

          <Tag3Table
            columns={[
              {name:'index', caption:'Index', dataType:'integer'},
              {name:'email', caption:'Email', dataType:'email'},
            ]}
            renderNoItems={loadingData ? returnLoadingDataSpinner : returnNoItemsContent}
            data={data}
          />
        </>
      );
    }`,
  },
};

const renderCellStory: Story = {
  title: 'custom cell',
  description: `Ability to custom render a table cell.`,
  reactWrapper_v3: {
    jsx: `<Example/>`,
    parentJSX: `
  const Example = () => {
  const [data, setData] = React.useState([{
      player: "Harry Kane", goals: 20, rate: 1 
    }, {
      player: "Raheem Sterling", goals: 10, rate: 0.5
    }, {
      player: "Jordan Pickford", goals: 0, rate: 0
    }
  ]);

  handleShootClick = (row) => () => {
    const hasScored = Math.random() < row.rate;
    if (hasScored) {
      const newData = data.map(d => d.player === row.player ? {...d, goals: d.goals + 1} : d);
      setData(newData);
    }
  }

  renderButton = ({ row }) => {
    if (row.rate === 0) {
      return null;
    }
    return <Tag3SimpleButton onButtonClick={handleShootClick(row)}>Shoot</Tag3SimpleButton>
  }

  return (
    <Tag3Table
      columns={[
        {name:'player', caption:'Player'},
        {name:'goals', caption:'Goals', dataType: 'integer'},
        {name:'shoot', caption:'', renderCell: renderButton, alignment: 'right'},
      ]}
      data={data}
    />
  );
}`,
  },
};

export const TagTableColumnDocs: Component = {
  type: 'component',
  name: 'table-column',
  description: `Defines a column in tag-table. This is specified as a nested element within tag-table.
For the React TagTable, a columns property is used to define the columns instead of a tag-table-column component. The properties for each column in the columns array are listed below`,
  mobileFriendly: false,
  popular: true,
  preRelease: '',
  props: [
    {
      name: 'name',
      type: 'string',
      description:
        'The name of the column. In v3 this needs to be unique within the set of columns. This references the property name in the data object. However, in v3 the field property can be used to reference the data field',
    },
    {
      name: 'field',
      type: 'string',
      description: 'v3 only. The field in the data to display in this columns',
    },
    {
      name: 'caption',
      type: 'string',
      description: 'The caption for the column header',
    },
    {
      name: 'dataType',
      type:
        'string | integer | decimal | currency | date | datetime | boolean | image | email | phonenumber',
      description: 'The type of data that the column will hold',
    },
    {
      name: 'alwaysVisible',
      type: 'boolean',
      description:
        'Whether the column should be always be visible and not allowed to be hidden in the column picker',
    },
    {
      name: 'alwaysHidden',
      type: 'boolean',
      description: 'Whether the column should always be hidden',
    },
    {
      name: 'defaultHidden',
      type: 'boolean',
      description: 'Whether the column should be hidden by default in the column picker',
    },
    {
      name: 'formattingOptions',
      type: 'string',
      description:
        'Additional formatting options for numbers. This maps directly to the options parameter in Intl.NumberFormat see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat',
    },
    {
      name: 'cellAccentField',
      type: 'string',
      description: 'The field in the data that gives the accent colour for the cell text',
    },
    {
      name: 'cellStyle',
      type: 'JSX style object in JSON to apply to each cell in the column',
      description: '',
    },
    {
      name: 'cellStyleField',
      type: 'string',
      description:
        'This points to a field in the data source that gives a JSON CSS object to apply to each cell in the column that has that field in its row',
    },
    {
      name: 'cellInnerStyle',
      type: 'string',
      description:
        'JSX style object in JSON CSS object to apply to each component in each cell in the column',
    },
    {
      name: 'cellInnerStyleField',
      type: 'string',
      description:
        'This points to a field in the data source that gives a JSON CSS object to apply to each component in each cell in the column',
    },
    {
      name: 'headerColumnStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply to the column header',
    },
    {
      name: 'headerColumnAlignment',
      type: 'left | center | right',
      description: 'The alignment of the column header',
    },
    {
      name: 'alignment',
      type: 'left | center | right',
      description: 'The alignment of the column',
    },
    {
      name: 'headerButtonStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply to the column header button when sortable',
    },
    {
      name: 'sortable',
      type: 'boolean',
      description: 'Whether the field can be sorted on',
    },
    {
      name: 'defaultHidden',
      type: 'string',
      description: 'Whether the column is hidden by default',
    },
  ],
  reactPropOverrides: [
    {
      name: 'key',
      type: 'string',
      description:
        'Deprecated in v3 (use name instead). A unique name for the column. Use this if you have multiple columns bound to the same data object property. This ends up being the key on the React elements',
    },
    {
      name: 'defaultSortDirection',
      type: 'unsorted | ascending | descending',
      description: 'If the column is sorted, the order it is sorted in',
    },
    {
      name: 'editor',
      type: 'IDataTableColumnEditor',
      description: 'The properties of the editor, if the column is editable',
    },
    {
      name: 'getColumnHeaderProps',
      type: ' (column?: ITagTableColumn) => object',
      description: 'v3 only. Function to return addition props to place on the th element',
    },
    {
      name: 'renderHeader',
      type: '() => JSX.Element',
      description: 'Function to custom render a column header',
    },
    {
      name: 'valueMapper',
      type: '(value: any, formattedValue: any) => any',
      description:
        'DEPRECATED in v3 (use mapCellValue). A function to execute after data for a cell is formatted before it is rendered. Allows custom formatting of data',
    },
    {
      name: 'mapCellValue',
      type:
        '(params: { column: ITagTableColumn, value: any, formattedValue: any, convertedValue: any }) => any',
      description: 'Function to lazily compute data within the cell',
    },
    {
      name: 'getCellProps',
      type: ' (column?: ITagTableColumn, value?: any) => object',
      description: 'v3 only. Function to return props on td element',
    },
    {
      name: 'renderCell',
      type:
        '({column,value,convertedValue,formattedValue,row,}: {column?: ITagTableColumn<T>;value?: any;convertedValue?: any;formattedValue?: any;row?: T;}) => React.ReactNode;',
      description: 'v3 only. Function to render the cell',
    },
    {
      name: 'renderCellField',
      type: 'string',
      description:
        'v3 only. Field in the row that contains the JSX for the cell (data driven rendering)',
    },
    {
      name: 'renderFooter',
      type: '(params: {column: ITagTableColumn, data: any[]}) => JSX.Element',
      description: 'Function to custom render a column footer. (params are only available in v3)',
    },
    {
      name: 'groupBy',
      type: '{on: boolean; suppressAggregates: boolean; }',
    },
    {
      name: 'aggregates',
      type: `Array<{type: 'sum' | 'count' | 'avg' | 'min' | 'max', }>`,
    },
  ],
  events: [],
  methods: [],
  stories: [],
};
export const TagTableColumnEditorDocs: Component = {
  type: 'component',
  name: 'table-column-editor',
  description: `Defines the editor for a column in tag-table. This is specified as a nested element within tag-table.
    For the React TagTable, an editor property in the column object is used to define the editor instead of a tag-table-column-editor component. The properties in the editor object are listed below`,
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'type',
      type:
        'textbox | multilinetextbox | email | number | dropdown | checkbox | toggle | slider | datepick',
      description: 'The type of the editor',
    },
    {
      name: 'defaultValue',
      type: 'any',
      description: 'The default value for the column for new rows',
    },
    {
      name: 'min',
      type: 'number',
      description: 'The minimum value for a number or slider',
    },
    {
      name: 'max',
      type: 'number',
      description: 'The maximum value for a number or slider',
    },
    {
      name: 'step',
      type: 'number',
      description: 'The increment value for a number or slider',
    },
    {
      name: 'maxLength',
      type: 'number',
      description: 'The maximum length for an edit field',
    },
    {
      name: 'disabledField',
      type: 'string',
      description: 'The field in the data that determines whether the cell is disabled',
    },
    {
      name: 'containerStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply',
    },
    {
      name: 'labelStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply',
    },
    {
      name: 'editorStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply',
    },
    {
      name: 'spanStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply',
    },
    {
      name: 'getOptions',
      type: '(options: any[], row: any) => any[]',
      description: ' A function that can be passed in to filter the list of drop down options down',
    },
  ],
  reactPropOverrides: [
    {
      name: 'options',
      type: '[{value: string, label: string, selected: boolean}]',
      description: 'The items in a drop down',
    },
  ],
  events: [],
  methods: [],
  stories: [],
};
export const TagTableDocs: Component = {
  type: 'component',
  name: 'table',
  description: 'Renders a table containing data',
  mobileFriendly: false,
  popular: true,
  preRelease: '',
  props: [
    {
      name: 'name',
      type: 'string',
      description: 'Unique name for table used for column picker caching',
    },
    {
      name: 'data',
      type: 'any[]',
      description: 'The data that determines the rows in the table',
    },
    {
      name: 'columns',
      type: 'IDataTableColumn[]',
      description: 'A property that can be used to set columns for the table at runtime.',
    },
    {
      name: 'accent',
      type: 'string',
      description: 'v3 only. Accent for things like the pager and column picker',
    },
    {
      name: 'page',
      description: 'The current page number',
      type: 'number',
    },
    {
      name: 'pageSize',
      description: 'The page size',
      type: 'number',
    },
    {
      name: 'pageCount',
      description: 'The total number of pages',
      type: 'number',
    },
    {
      name: 'recordCount',
      description: 'Deprecated in v3 (redundant). The total number of records',
      type: 'number',
    },
    {
      name: 'pagerAccent',
      description: 'Deprecated in v3 (use accent). The color of pager',
      type: 'Accent',
    },
    {
      name: 'pagerShowFirstLast',
      description: 'Whether the "go to first" and "go to last" pager buttons are visible',
      type: 'boolean',
    },
    {
      name: 'pagerAlign',
      description: 'The alignment of the pager',
      type: `'left' | 'right' | 'center'`,
      default: 'right',
    },
    {
      name: 'renderPager',
      description: 'A function to custom render a pager (or anything at the bottom of the table',
      type: `() => React.ReactNode`,
    },
    {
      name: 'renderNoItems',
      description:
        'V3 Only: A function to custom render a pager (or anything at the bottom of the table',
      type: `() => React.ReactNode`,
    },
    {
      name: 'height',
      description: 'The height of the table (if set the table will be scrollable)',
      type: 'string',
    },
    {
      name: 'showColumnPicker',
      description: 'Whether the column picker is available or not',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'allowDataTypeEditing',
      description: 'Whether the column picker allows the column data types to be changed',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'allowCaptionEditing',
      description: 'Whether the column picker allows the column captions to be changed',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'saveColumnPickerColumns',
      description: 'Function to save columns if custom column caching is used',
      type:
        '(columns: Array<{name: string;caption: string;visible: boolean;alwaysVisible: boolean;alwaysHidden: boolean;dataType: ColumnDataType;}>) => Promise<void>',
    },
    {
      name: 'getResetColumns',
      description: 'Function to return the reset columns if custom column caching is used',
      type: '() => Promise<Column<T>[]>',
    },
    {
      name: 'cacheColumns',
      description:
        'Deprecated in v3 (see custom cache demo). Whether to cache the columns to the application storage, when used with column picker',
      type: 'boolean',
      default: 'true',
    },
    {
      name: 'getCache',
      description:
        'Deprecated in v3 (see custom cache demo). A function prop that can be used to override getting the columns from the cache. Useful if implementing a server side cache',
      type: 'property method',
    },
    {
      name: 'setCache',
      description:
        'Deprecated in v3 (see custom cache demo). A function prop that can be used to override setting the columns from the cache. Useful if implementing a server side cache',
      type: 'property method',
    },
    {
      name: 'removeCache',
      description:
        'Deprecated in v3 (see custom cache demo). A function prop that can be used to override removing the columns from the cache. Useful if implementing a server side cache',
      type: 'property method',
    },
    {
      name: 'tableContainerStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply',
    },
    {
      name: 'tableStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply',
    },
    {
      name: 'tableProps',
      type: 'object',
      description: 'Additional props on table element',
    },
    {
      name: 'columnHeaderRowProps',
      type: 'object',
      description: 'Additional props on row element for column headers',
    },
    {
      name: 'bodyProps',
      type: 'object',
      description: 'Additional props on body element',
    },
    {
      name: 'mapRow',
      type: '(row: any) => any',
      description: 'Function to lazily compute data within the row',
    },
    {
      name: 'rowStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply',
    },
    {
      name: 'rowStyleField',
      type: 'string',
      description:
        'This points to a field in the data source that gives a JSON CSS object to apply to the row.',
    },
    {
      name: 'rowKeyField',
      type: 'string',
      description: 'Field in the row to get the unique key from.',
    },
    {
      name: 'getRowProps',
      type: '(row: any) => object',
      description: 'Additional props on row element',
    },
    {
      name: 'selectable',
      description: 'Whether rows are selectable or not',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'selectedRow',
      description: 'The key value for the row to be selected',
      type: 'any',
    },
    {
      name: 'button',
      description: 'Caption for a row action button',
      type: 'string',
    },
    {
      name: 'buttonAccent',
      description: 'Background colour for a row action button',
      type: 'string',
    },
    {
      name: 'buttonIcon',
      description: 'Icon for a row action button',
      type: 'string',
    },
    {
      name: 'buttonIconAccent',
      description: 'Icon colour for a row action button',
      type: 'string',
    },
    {
      name: 'buttonDisabled',
      description: 'Whether the row action button is disabled',
      type: 'boolean',
    },
    {
      name: 'buttonRounded',
      description: 'Whether the row action button is rounded',
      type: 'boolean',
    },
    {
      name: 'buttonStyle',
      description: 'The style of the row action button',
      type: 'string',
    },
    {
      name: 'multiCheck',
      description: 'Whether multi check mode is on',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'multiCheckDefaultRowKeysChecked',
      description:
        'v3 only. The row keys to be selected by default. The row key in the data is defined by the rowKeyField prop or is the numeric row index if this is not supplied',
      type: 'any[]',
    },
    {
      name: 'multiCheckAlign',
      description: 'Checkbox alignment in the table when  multi check mode is on',
      type: 'left | right',
      default: 'left',
    },
    {
      name: 'multiCheckSuppressAll',
      description: 'Whether the Select All option is suppressed when multi check mode is on',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'multiCheckSize',
      description: 'The size of the checkboxes when multi check mode is on',
      type: 'normal | large',
      default: 'normal',
    },
    {
      name: 'multiCheckRounded',
      description: 'Whether the checkboxes are rounded when multi check mode is on',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'multiCheckAccent',
      description: 'The colour of the checkboxes when multi check mode is on',
      type: 'string',
    },
    {
      name: 'sort',
      description:
        'A function to handle the sort. By default a clientside sort is performed if a function is not specified',
      type:
        '(columnName: string, columnSortDirection: "unsorted" | "ascending" | "descending", data: any[]) => Promise<{columnSortDirection: "unsorted" | "ascending" | "descending"; data: any[]}>',
    },
    {
      name: 'displayValidationMessages',
      description: 'The way validation messages are displayed in a table',
      type: `'flow' | 'overlay'`,
      default: 'flow',
    },
    {
      name: 'footerRowProps',
      type: 'object',
      description: 'Additional props on row element for footer',
    },
  ],
  reactPropOverrides: [
    {
      name: 'addButton',
      description: 'Definition for an add button if the table is editable',
      type:
        '{caption: string, icon: string, accent: string, iconAccent: string, disabled: boolean, rounded: boolean, squared: boolean, style: CSSProperties}',
    },
    {
      name: 'addButtonAlign',
      description: 'Where the add button is located',
      type: "'left' | 'right' | 'center'",
    },
    {
      name: 'addButtonVerticalAlign',
      description: 'Where the add button is vertically located',
      type: "'top' | 'bottom'",
    },
    {
      name: 'deleteButton',
      description: 'Definition for a delete button if the table is editable',
      type:
        '{caption: string, icon: string, accent: string, iconAccent: string, disabled: boolean, rounded: boolean, squared: boolean, style: CSSProperties}',
    },
  ],
  events: [
    {
      name: 'buttonClick',
      description: 'Deprecated since version 1.6.1, please use rowButtonClick',
      parameters: [
        {
          name: 'row',
          description: 'The data behind the row where the button was clicked',
          type: 'any',
        },
      ],
    },
    {
      name: 'rowButtonClick',
      description: 'Raised when a row button is clicked',
      parameters: [
        {
          name: 'row',
          description: 'The data behind the row where the button was clicked',
          type: 'any',
        },
      ],
    },
    {
      name: 'rowSelected',
      description: 'Raised when the table is selectable and a row is selected',
      parameters: [
        {
          name: 'row',
          description: 'The data behind the row where the button was clicked',
          type: 'any',
        },
      ],
    },
    {
      name: 'pageRequest',
      description: 'Event raised when a page button is clicked',
      parameters: [
        {
          name: 'page',
          description: 'The page number',
          type: 'number',
        },
      ],
    },
    {
      name: 'tableValueChange',
      description: 'Event raised when table value is changed',
      parameters: [
        {
          name: 'name',
          description: 'The field name',
          type: 'string',
        },
        {
          name: 'rawValue',
          description: 'The field value before any conversion',
          type: 'any',
        },
        {
          name: 'value',
          description: 'The field value',
          type: 'any',
        },
        {
          name: 'row',
          description: 'The data behind the row that changed',
          type: 'any',
        },
        {
          name: 'data',
          description: 'The data in the whole table',
          type: 'any[]',
        },
      ],
    },
    {
      name: 'rowAdd',
      description: 'Event raised when a row is added',
      parameters: [
        {
          name: 'row',
          description:
            'The data behind the row that was added. Changes that are made to the row will be rendered in the new row',
          type: 'any',
        },
        {
          name: 'data',
          description: 'The data in the whole table',
          type: 'any[]',
        },
      ],
    },
    {
      name: 'rowDelete',
      description: 'Event raised when a row is deleted',
      parameters: [
        {
          name: 'row',
          description: 'The data behind the row that was deleted',
          type: 'any',
        },
        {
          name: 'data',
          description: 'The data in the whole table',
          type: 'any[]',
        },
      ],
    },
    {
      name: 'rowsChecked',
      description: 'Raised when table rows are checked',
      parameters: [
        {
          name: 'changes',
          description: 'An array of rows that have just been checked / unchecked',
          type: '{row: any, checked: boolean}[]',
        },
        {
          name: 'checkedRows',
          description: 'An array of currently checked rows. Returns [] when all unchecked.',
          type: 'any[]',
        },
      ],
    },
    {
      name: 'tableSorted',
      description: 'Event raised after a sort has occurred',
      parameters: [
        {
          name: 'data',
          description: 'The sorted data',
          type: 'any[]',
        },
        {
          name: 'columnSortDirections',
          description: 'The column sort ordering',
          type: '{ [key: string]: "unsorted" | "ascending" | "descending" }',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'select',
      description: 'Select a row if the tag-table is selectable',
      parameters: [
        {
          name: 'row',
          description: 'The row you want to select',
          type: 'any',
        },
        {
          name: 'suppressRowSelectedEvent',
          description: 'true if you want not to emmit the event',
          type: 'boolean',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'setData',
      description: 'Sets the data and paging information for this component',
      parameters: [
        {
          name: 'data',
          description: 'The data to bind to the table',
          type: 'IPagedData | any[]',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'setSort',
      description: 'set the sort direction on a number of columns in the table',
      parameters: [
        {
          name: 'sortDirectionArray',
          description:
            'Array of column names and the sort direction - unsorted | ascending | descending',
          type: 'any[]',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'getCheckedRows',
      description: 'Gets the checked rows in the table',
      parameters: [],
      returnType: 'any[]',
    },
    {
      name: 'setCheckedRows',
      description: 'Sets the checked rows in the table',
      parameters: [
        {
          name: 'rows',
          description: 'The array of rows to check',
          type: 'any[]',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'validateTableRemote',
      description: 'Triggers the remote validation rules to be invoked on the table/row/cell',
      parameters: [
        {
          name: 'rowIndex',
          description: 'The table row index that needs to be validated (optional)',
          type: 'number',
        },
        {
          name: 'colIndex',
          description: 'The column index of the table row that needs to be validated (optional)',
          type: 'number',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'refreshColumnsDefinition',
      description: 'HTML ONLY: Forces a refresh of internal columns definition.',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [
    DataTypesStory,
    LargeTableStory,
    FormattingStory,
    HighlightedRowsStory,
    HighlightedCellsStory,
    ButtonStory,
    SelectableStory,
    SelectableControlledStory,
    MultiCheckStory,
    MulticheckPerfStory,
    ClientSortingStory,
    externalSortingStory,
    CustomSortingStory,
    HeaderAlignmentStory,
    ClientPagingStory,
    ColumnPickerStory,
    ColumnCachingStory,
    AutoformattingStory,
    GroupingStory,
    MultipleGroupingStory,
    PagerSlotStory,
    CustomCellRenderingStory,
    EditableTableStory,
    EditableTableWithDisabledCellsStory,
    EditableTableWithCustomValidationStory,
    DataMappingStory,
    CustomHeaderAndFooterStory,
    ValidateAllTableStory,
    ValidateRowTableStory,
    RefreshStory,
    NoItemsStory,
    renderCellStory,
  ],
  childComponents: [TagTableColumnDocs, TagTableColumnEditorDocs],
};
